/* tslint:disable */
/* eslint-disable */
/* !!! THIS FILE IS GENERATED, DO NOT EDIT !!! */
import {
    DevEnv,
    HTMLElementAttributes,
    Schema
} from 'ability-attributes';

export type Body_Params = {
    
}

export class Body extends Schema.AttributeSchema<Body_Params> {
    static className = "Body";
    private static _tagsByTag: Schema.TagsByTag = {"body":"<body>"};
    private static _allParamsByTag = Schema.AttributeSchema._assignTagNames({
        "<body>": {}
    }, Body._tagsByTag);
    private static _attrToParamByTag = Schema.AttributeSchema._assignTagNames({
        "<body>": {}
    }, Body._tagsByTag);
    private static _paramToAttrByTag = Schema.AttributeSchema._assignTagNames({
        "<body>": {}
    }, Body._tagsByTag);
    private static _nonParamAttrsByTag = Schema.AttributeSchema._assignTagNames({
        "<body>": {}
    }, Body._tagsByTag);
    private static _mandatoryParams = {};

    protected _className = Body.className;
    protected _allParamsByTag = Body._allParamsByTag;
    protected _attrToParamByTag = Body._attrToParamByTag;
    protected _mandatoryParams = Body._mandatoryParams;
    protected _nonParamAttrsByTag = Body._nonParamAttrsByTag;

    constructor(tagName: string, params: Body_Params) {
        super(tagName, params);

        if (process.env.NODE_ENV !== 'production') {
            const classConstraints: Schema.Constraint[] = [];

            const tagConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({}, Body._tagsByTag)[tagName];

            const paramConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({
                "<body>": {}
            }, Body._tagsByTag)[tagName];

            const paramOptionalConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({
                "<body>": {}
            }, Body._tagsByTag)[tagName];

            this.getConstraints = () => {
                const constraints: Schema.ParamConstraint[] = classConstraints.slice(0);

                if (tagConstraints) {
                    Array.prototype.push.apply(constraints, tagConstraints);
                }

                for (let paramName of Object.keys(paramConstraints)) {
                    if (paramName in this._params) {
                        Array.prototype.push.apply(constraints, paramConstraints[paramName].map(c => {
                            return { ...c, name: paramName, value: this._params[paramName as keyof Body_Params] };
                        }));
                    }
                }

                for (let paramName of Object.keys(paramOptionalConstraints)) {
                    const paramNames = paramName.split(', ');
                    const paramNamesText = paramNames.map(p => `'${ p }'`).join(' or ');

                    if (!(paramNames.some(n => n in this._params))) {
                        Array.prototype.push.apply(
                            constraints,
                            paramOptionalConstraints[paramName].map(c => { return { ...c, param: paramNamesText }; })
                        );
                    }
                }

                return constraints;
            };
        }
    }

    static fromAttributes(tagName: string, attributes: HTMLElementAttributes): Body {
        const pd = Schema.AttributeSchema._getParamsFromAttributes<Body_Params>(
            tagName,
            attributes,
            Body.className,
            Body._allParamsByTag,
            Body._attrToParamByTag,
            Body._paramToAttrByTag,
            Body._mandatoryParams,
            Body._nonParamAttrsByTag
        );

        const instance = new Body(tagName, pd.params);

        instance._setDefaults(pd.defaults);

        return instance;
    }
}

if (process.env.NODE_ENV !== 'production') {
    Body.assume = function(tagName: string, attributes: HTMLElementAttributes): Schema.AssumptionSpecificity | undefined {
        const assumptions: Schema.ClassAssumption[] = [
            {
                "tag": "body"
            }
        ];

        for (let a of assumptions) {
            let tagMatch = false;
            let attributeMatch = 0;

            if ('tag' in a) {
                if (a.tag !== tagName) {
                    continue;
                }

                tagMatch = true;
            }

            if ('attributes' in a) {
                for (let attr of a.attributes) {
                    if (!(attr.name in attributes) || (attributes[attr.name] !== attr.value)) {
                        attributeMatch = 0;
                        break;
                    }

                    attributeMatch++;
                }

                if (attributeMatch === 0) {
                    continue;
                }
            } else if (!tagMatch) {
                continue;
            }

            return { tag: tagMatch, attributes: attributeMatch };
        }

        return undefined;
    };
}

export type Header1_Params = {
    label?: string;
    labelledBy?: never;
    
} | {
    label?: never;
    labelledBy?: string;
    
}

export class Header1 extends Schema.AttributeSchema<Header1_Params> {
    static className = "Header1";
    private static _tagsByTag: Schema.TagsByTag = {"h1":"<h1>","div":"<div>"};
    private static _allParamsByTag = Schema.AttributeSchema._assignTagNames({
        "<h1>": {
            "label": {
                "class": "3",
                "param": {
                    "name": "label",
                    "attributes": [
                        {
                            "name": "aria-label"
                        }
                    ]
                }
            },
            "labelledBy": {
                "class": "3",
                "param": {
                    "name": "labelledBy",
                    "attributes": [
                        {
                            "name": "aria-labelledby"
                        }
                    ]
                }
            }
        },
        "<div>": {
            "label": {
                "class": "3",
                "param": {
                    "name": "label",
                    "attributes": [
                        {
                            "name": "aria-label"
                        }
                    ]
                }
            },
            "labelledBy": {
                "class": "3",
                "param": {
                    "name": "labelledBy",
                    "attributes": [
                        {
                            "name": "aria-labelledby"
                        }
                    ]
                }
            }
        }
    }, Header1._tagsByTag);
    private static _attrToParamByTag = Schema.AttributeSchema._assignTagNames({
        "<h1>": {
            "aria-label": "label",
            "aria-labelledby": "labelledBy"
        },
        "<div>": {
            "aria-label": "label",
            "aria-labelledby": "labelledBy"
        }
    }, Header1._tagsByTag);
    private static _paramToAttrByTag = Schema.AttributeSchema._assignTagNames({
        "<h1>": {
            "label": "aria-label",
            "labelledBy": "aria-labelledby"
        },
        "<div>": {
            "label": "aria-label",
            "labelledBy": "aria-labelledby"
        }
    }, Header1._tagsByTag);
    private static _nonParamAttrsByTag = Schema.AttributeSchema._assignTagNames({
        "<h1>": {},
        "<div>": {
            "role": {
                "class": "1",
                "attr": {
                    "name": "role",
                    "default": "heading",
                    "value": {
                        "heading": true
                    }
                }
            },
            "aria-level": {
                "class": "2",
                "attr": {
                    "name": "aria-level",
                    "default": "1",
                    "value": {
                        "1": true
                    }
                }
            }
        }
    }, Header1._tagsByTag);
    private static _mandatoryParams = {};

    protected _className = Header1.className;
    protected _allParamsByTag = Header1._allParamsByTag;
    protected _attrToParamByTag = Header1._attrToParamByTag;
    protected _mandatoryParams = Header1._mandatoryParams;
    protected _nonParamAttrsByTag = Header1._nonParamAttrsByTag;

    constructor(tagName: string, params: Header1_Params) {
        super(tagName, params);

        if (process.env.NODE_ENV !== 'production') {
            const classConstraints: Schema.Constraint[] = [];

            const tagConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({}, Header1._tagsByTag)[tagName];

            const paramConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({
                "<h1>": {
                    "label": [
                        {
                            "xpath": "normalize-space(@aria-label) != ''",
                            "description": "aria-label attribute value cannot be empty"
                        }
                    ],
                    "labelledBy": [
                        {
                            "js": "checkIdentifiers",
                            "description": "Value must be space-separated list of existing element identifiers"
                        }
                    ]
                },
                "<div>": {
                    "label": [
                        {
                            "xpath": "normalize-space(@aria-label) != ''",
                            "description": "aria-label attribute value cannot be empty"
                        }
                    ],
                    "labelledBy": [
                        {
                            "js": "checkIdentifiers",
                            "description": "Value must be space-separated list of existing element identifiers"
                        }
                    ]
                }
            }, Header1._tagsByTag)[tagName];

            const paramOptionalConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({
                "<h1>": {
                    "label, labelledBy": [
                        {
                            "xpath": "boolean(@title and @title != '') or boolean(.//text()[normalize-space(.) != ''])",
                            "description": "Element must contain text nodes or title attribute"
                        }
                    ]
                },
                "<div>": {
                    "label, labelledBy": [
                        {
                            "xpath": "boolean(@title and @title != '') or boolean(.//text()[normalize-space(.) != ''])",
                            "description": "Element must contain text nodes or title attribute"
                        }
                    ]
                }
            }, Header1._tagsByTag)[tagName];

            this.getConstraints = () => {
                const constraints: Schema.ParamConstraint[] = classConstraints.slice(0);

                if (tagConstraints) {
                    Array.prototype.push.apply(constraints, tagConstraints);
                }

                for (let paramName of Object.keys(paramConstraints)) {
                    if (paramName in this._params) {
                        Array.prototype.push.apply(constraints, paramConstraints[paramName].map(c => {
                            return { ...c, name: paramName, value: this._params[paramName as keyof Header1_Params] };
                        }));
                    }
                }

                for (let paramName of Object.keys(paramOptionalConstraints)) {
                    const paramNames = paramName.split(', ');
                    const paramNamesText = paramNames.map(p => `'${ p }'`).join(' or ');

                    if (!(paramNames.some(n => n in this._params))) {
                        Array.prototype.push.apply(
                            constraints,
                            paramOptionalConstraints[paramName].map(c => { return { ...c, param: paramNamesText }; })
                        );
                    }
                }

                return constraints;
            };
        }
    }

    static fromAttributes(tagName: string, attributes: HTMLElementAttributes): Header1 {
        const pd = Schema.AttributeSchema._getParamsFromAttributes<Header1_Params>(
            tagName,
            attributes,
            Header1.className,
            Header1._allParamsByTag,
            Header1._attrToParamByTag,
            Header1._paramToAttrByTag,
            Header1._mandatoryParams,
            Header1._nonParamAttrsByTag
        );

        const instance = new Header1(tagName, pd.params);

        instance._setDefaults(pd.defaults);

        return instance;
    }
}

if (process.env.NODE_ENV !== 'production') {
    Header1.assume = function(tagName: string, attributes: HTMLElementAttributes): Schema.AssumptionSpecificity | undefined {
        const assumptions: Schema.ClassAssumption[] = [
            {
                "tag": "h1"
            },
            {
                "tag": "div",
                "attributes": [
                    {
                        "name": "role",
                        "value": "heading"
                    },
                    {
                        "name": "aria-level",
                        "value": "1"
                    }
                ]
            }
        ];

        for (let a of assumptions) {
            let tagMatch = false;
            let attributeMatch = 0;

            if ('tag' in a) {
                if (a.tag !== tagName) {
                    continue;
                }

                tagMatch = true;
            }

            if ('attributes' in a) {
                for (let attr of a.attributes) {
                    if (!(attr.name in attributes) || (attributes[attr.name] !== attr.value)) {
                        attributeMatch = 0;
                        break;
                    }

                    attributeMatch++;
                }

                if (attributeMatch === 0) {
                    continue;
                }
            } else if (!tagMatch) {
                continue;
            }

            return { tag: tagMatch, attributes: attributeMatch };
        }

        return undefined;
    };
}

export type TreeItem_Params = {
    title?: string;
    isExpanded: true | false;
    isSelected?: true;
    setsize: string;
    posinset: string;
    level: string;
    tabbable?: true | false;
}

export class TreeItem extends Schema.AttributeSchema<TreeItem_Params> {
    static className = "TreeItem";
    private static _tagsByTag: Schema.TagsByTag = {"div":"<div>, <span>, <a>","span":"<div>, <span>, <a>","a":"<div>, <span>, <a>"};
    private static _allParamsByTag = Schema.AttributeSchema._assignTagNames({
        "<div>, <span>, <a>": {
            "title": {
                "class": "3",
                "param": {
                    "name": "title",
                    "attributes": [
                        {
                            "name": "title"
                        }
                    ]
                }
            },
            "isExpanded": {
                "class": "4",
                "param": {
                    "name": "isExpanded",
                    "attributes": [
                        {
                            "name": "aria-expanded",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "isSelected": {
                "class": "5",
                "param": {
                    "name": "isSelected",
                    "attributes": [
                        {
                            "name": "aria-selected",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": true,
                                    "attribute": "false"
                                }
                            ]
                        }
                    ]
                }
            },
            "setsize": {
                "class": "6",
                "param": {
                    "name": "setsize",
                    "attributes": [
                        {
                            "name": "aria-setsize"
                        }
                    ]
                }
            },
            "posinset": {
                "class": "7",
                "param": {
                    "name": "posinset",
                    "attributes": [
                        {
                            "name": "aria-posinset"
                        }
                    ]
                }
            },
            "level": {
                "class": "8",
                "param": {
                    "name": "level",
                    "attributes": [
                        {
                            "name": "aria-level"
                        }
                    ]
                }
            },
            "tabbable": {
                "class": "9",
                "param": {
                    "name": "tabbable",
                    "attributes": [
                        {
                            "name": "tabindex",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "0"
                                },
                                {
                                    "parameter": false,
                                    "attribute": "-1"
                                }
                            ]
                        }
                    ]
                }
            }
        }
    }, TreeItem._tagsByTag);
    private static _attrToParamByTag = Schema.AttributeSchema._assignTagNames({
        "<div>, <span>, <a>": {
            "title": "title",
            "aria-expanded": "isExpanded",
            "aria-selected": "isSelected",
            "aria-setsize": "setsize",
            "aria-posinset": "posinset",
            "aria-level": "level",
            "tabindex": "tabbable"
        }
    }, TreeItem._tagsByTag);
    private static _paramToAttrByTag = Schema.AttributeSchema._assignTagNames({
        "<div>, <span>, <a>": {
            "title": "title",
            "isExpanded": "aria-expanded",
            "isSelected": "aria-selected",
            "setsize": "aria-setsize",
            "posinset": "aria-posinset",
            "level": "aria-level",
            "tabbable": "tabindex"
        }
    }, TreeItem._tagsByTag);
    private static _nonParamAttrsByTag = Schema.AttributeSchema._assignTagNames({
        "<div>, <span>, <a>": {
            "role": {
                "class": "1",
                "attr": {
                    "name": "role",
                    "default": "treeitem",
                    "value": {
                        "treeitem": true
                    }
                }
            },
            "tabindex": {
                "class": "2",
                "attr": {
                    "name": "tabindex",
                    "default": "0",
                    "value": {
                        "0": true,
                        "-1": true
                    }
                }
            }
        }
    }, TreeItem._tagsByTag);
    private static _mandatoryParams = {
        "4": [
            "isExpanded"
        ],
        "6": [
            "setsize"
        ],
        "7": [
            "posinset"
        ],
        "8": [
            "level"
        ]
    };

    protected _className = TreeItem.className;
    protected _allParamsByTag = TreeItem._allParamsByTag;
    protected _attrToParamByTag = TreeItem._attrToParamByTag;
    protected _mandatoryParams = TreeItem._mandatoryParams;
    protected _nonParamAttrsByTag = TreeItem._nonParamAttrsByTag;

    constructor(tagName: string, params: TreeItem_Params) {
        super(tagName, params);

        if (process.env.NODE_ENV !== 'production') {
            const classConstraints: Schema.Constraint[] = [
                {
                    "xpath": "not(boolean((.//*[@role and @role != 'none' and @role != 'presentation'] | .//a | .//area | .//button | .//input | .//object | .//select | .//textarea)[not(ancestor-or-self::*/@aria-hidden = 'true')]))",
                    "description": "Element cannot contain other accessible elements"
                }
            ];

            const tagConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({}, TreeItem._tagsByTag)[tagName];

            const paramConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({
                "<div>, <span>, <a>": {
                    "title": [
                        {
                            "xpath": "normalize-space(@title) != ''",
                            "description": "title attribute value cannot be empty"
                        },
                        {
                            "js": "equalsToAccessibilityLabelIfAny",
                            "description": "In order to not confuse the users, the title attribute value should be equal to the accessibility label value"
                        }
                    ],
                    "setsize": [
                        {
                            "xpath": "number(@aria-setsize) = @aria-setsize",
                            "description": "aria-setsize attribute value should be a number"
                        }
                    ],
                    "posinset": [
                        {
                            "xpath": "number(@aria-posinset) = @aria-posinset",
                            "description": "aria-posinset attribute value should be a number"
                        }
                    ],
                    "level": [
                        {
                            "xpath": "number(@aria-level) = @aria-level",
                            "description": "aria-level attribute value should be a number"
                        }
                    ]
                }
            }, TreeItem._tagsByTag)[tagName];

            const paramOptionalConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({
                "<div>, <span>, <a>": {}
            }, TreeItem._tagsByTag)[tagName];

            this.getConstraints = () => {
                const constraints: Schema.ParamConstraint[] = classConstraints.slice(0);

                if (tagConstraints) {
                    Array.prototype.push.apply(constraints, tagConstraints);
                }

                for (let paramName of Object.keys(paramConstraints)) {
                    if (paramName in this._params) {
                        Array.prototype.push.apply(constraints, paramConstraints[paramName].map(c => {
                            return { ...c, name: paramName, value: this._params[paramName as keyof TreeItem_Params] };
                        }));
                    }
                }

                for (let paramName of Object.keys(paramOptionalConstraints)) {
                    const paramNames = paramName.split(', ');
                    const paramNamesText = paramNames.map(p => `'${ p }'`).join(' or ');

                    if (!(paramNames.some(n => n in this._params))) {
                        Array.prototype.push.apply(
                            constraints,
                            paramOptionalConstraints[paramName].map(c => { return { ...c, param: paramNamesText }; })
                        );
                    }
                }

                return constraints;
            };
        }
    }

    static fromAttributes(tagName: string, attributes: HTMLElementAttributes): TreeItem {
        const pd = Schema.AttributeSchema._getParamsFromAttributes<TreeItem_Params>(
            tagName,
            attributes,
            TreeItem.className,
            TreeItem._allParamsByTag,
            TreeItem._attrToParamByTag,
            TreeItem._paramToAttrByTag,
            TreeItem._mandatoryParams,
            TreeItem._nonParamAttrsByTag
        );

        const instance = new TreeItem(tagName, pd.params);

        instance._setDefaults(pd.defaults);

        return instance;
    }
}


export type TreeTitle_Params = {
    title?: string;
    isSelected?: true;
    setsize: string;
    posinset: string;
    level: string;
    tabbable?: true | false;
}

export class TreeTitle extends Schema.AttributeSchema<TreeTitle_Params> {
    static className = "TreeTitle";
    private static _tagsByTag: Schema.TagsByTag = {"div":"<div>, <span>, <a>","span":"<div>, <span>, <a>","a":"<div>, <span>, <a>"};
    private static _allParamsByTag = Schema.AttributeSchema._assignTagNames({
        "<div>, <span>, <a>": {
            "title": {
                "class": "3",
                "param": {
                    "name": "title",
                    "attributes": [
                        {
                            "name": "title"
                        }
                    ]
                }
            },
            "isSelected": {
                "class": "4",
                "param": {
                    "name": "isSelected",
                    "attributes": [
                        {
                            "name": "aria-selected",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": true,
                                    "attribute": "false"
                                }
                            ]
                        }
                    ]
                }
            },
            "setsize": {
                "class": "5",
                "param": {
                    "name": "setsize",
                    "attributes": [
                        {
                            "name": "aria-setsize"
                        }
                    ]
                }
            },
            "posinset": {
                "class": "6",
                "param": {
                    "name": "posinset",
                    "attributes": [
                        {
                            "name": "aria-posinset"
                        }
                    ]
                }
            },
            "level": {
                "class": "7",
                "param": {
                    "name": "level",
                    "attributes": [
                        {
                            "name": "aria-level"
                        }
                    ]
                }
            },
            "tabbable": {
                "class": "8",
                "param": {
                    "name": "tabbable",
                    "attributes": [
                        {
                            "name": "tabindex",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "0"
                                },
                                {
                                    "parameter": false,
                                    "attribute": "-1"
                                }
                            ]
                        }
                    ]
                }
            }
        }
    }, TreeTitle._tagsByTag);
    private static _attrToParamByTag = Schema.AttributeSchema._assignTagNames({
        "<div>, <span>, <a>": {
            "title": "title",
            "aria-selected": "isSelected",
            "aria-setsize": "setsize",
            "aria-posinset": "posinset",
            "aria-level": "level",
            "tabindex": "tabbable"
        }
    }, TreeTitle._tagsByTag);
    private static _paramToAttrByTag = Schema.AttributeSchema._assignTagNames({
        "<div>, <span>, <a>": {
            "title": "title",
            "isSelected": "aria-selected",
            "setsize": "aria-setsize",
            "posinset": "aria-posinset",
            "level": "aria-level",
            "tabbable": "tabindex"
        }
    }, TreeTitle._tagsByTag);
    private static _nonParamAttrsByTag = Schema.AttributeSchema._assignTagNames({
        "<div>, <span>, <a>": {
            "role": {
                "class": "1",
                "attr": {
                    "name": "role",
                    "default": "treeitem",
                    "value": {
                        "treeitem": true
                    }
                }
            },
            "tabindex": {
                "class": "2",
                "attr": {
                    "name": "tabindex",
                    "default": "0",
                    "value": {
                        "0": true,
                        "-1": true
                    }
                }
            }
        }
    }, TreeTitle._tagsByTag);
    private static _mandatoryParams = {
        "5": [
            "setsize"
        ],
        "6": [
            "posinset"
        ],
        "7": [
            "level"
        ]
    };

    protected _className = TreeTitle.className;
    protected _allParamsByTag = TreeTitle._allParamsByTag;
    protected _attrToParamByTag = TreeTitle._attrToParamByTag;
    protected _mandatoryParams = TreeTitle._mandatoryParams;
    protected _nonParamAttrsByTag = TreeTitle._nonParamAttrsByTag;

    constructor(tagName: string, params: TreeTitle_Params) {
        super(tagName, params);

        if (process.env.NODE_ENV !== 'production') {
            const classConstraints: Schema.Constraint[] = [
                {
                    "xpath": "not(boolean((.//*[@role and @role != 'none' and @role != 'presentation'] | .//a | .//area | .//button | .//input | .//object | .//select | .//textarea)[not(ancestor-or-self::*/@aria-hidden = 'true')]))",
                    "description": "Element cannot contain other accessible elements"
                }
            ];

            const tagConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({}, TreeTitle._tagsByTag)[tagName];

            const paramConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({
                "<div>, <span>, <a>": {
                    "title": [
                        {
                            "xpath": "normalize-space(@title) != ''",
                            "description": "title attribute value cannot be empty"
                        },
                        {
                            "js": "equalsToAccessibilityLabelIfAny",
                            "description": "In order to not confuse the users, the title attribute value should be equal to the accessibility label value"
                        }
                    ],
                    "setsize": [
                        {
                            "xpath": "number(@aria-setsize) = @aria-setsize",
                            "description": "aria-setsize attribute value should be a number"
                        }
                    ],
                    "posinset": [
                        {
                            "xpath": "number(@aria-posinset) = @aria-posinset",
                            "description": "aria-posinset attribute value should be a number"
                        }
                    ],
                    "level": [
                        {
                            "xpath": "number(@aria-level) = @aria-level",
                            "description": "aria-level attribute value should be a number"
                        }
                    ]
                }
            }, TreeTitle._tagsByTag)[tagName];

            const paramOptionalConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({
                "<div>, <span>, <a>": {}
            }, TreeTitle._tagsByTag)[tagName];

            this.getConstraints = () => {
                const constraints: Schema.ParamConstraint[] = classConstraints.slice(0);

                if (tagConstraints) {
                    Array.prototype.push.apply(constraints, tagConstraints);
                }

                for (let paramName of Object.keys(paramConstraints)) {
                    if (paramName in this._params) {
                        Array.prototype.push.apply(constraints, paramConstraints[paramName].map(c => {
                            return { ...c, name: paramName, value: this._params[paramName as keyof TreeTitle_Params] };
                        }));
                    }
                }

                for (let paramName of Object.keys(paramOptionalConstraints)) {
                    const paramNames = paramName.split(', ');
                    const paramNamesText = paramNames.map(p => `'${ p }'`).join(' or ');

                    if (!(paramNames.some(n => n in this._params))) {
                        Array.prototype.push.apply(
                            constraints,
                            paramOptionalConstraints[paramName].map(c => { return { ...c, param: paramNamesText }; })
                        );
                    }
                }

                return constraints;
            };
        }
    }

    static fromAttributes(tagName: string, attributes: HTMLElementAttributes): TreeTitle {
        const pd = Schema.AttributeSchema._getParamsFromAttributes<TreeTitle_Params>(
            tagName,
            attributes,
            TreeTitle.className,
            TreeTitle._allParamsByTag,
            TreeTitle._attrToParamByTag,
            TreeTitle._paramToAttrByTag,
            TreeTitle._mandatoryParams,
            TreeTitle._nonParamAttrsByTag
        );

        const instance = new TreeTitle(tagName, pd.params);

        instance._setDefaults(pd.defaults);

        return instance;
    }
}


export type Button_Params = {
    label?: string;
    labelledBy?: never;
    title?: string;
    describedBy?: string;
    hasPopup?: true | false;
    isExpanded?: true | false;
    isPressed?: true | false;
    tabbable?: true | false;
    disabled?: true | false;
} | {
    label?: never;
    labelledBy?: string;
    title?: string;
    describedBy?: string;
    hasPopup?: true | false;
    isExpanded?: true | false;
    isPressed?: true | false;
    tabbable?: true | false;
    disabled?: true | false;
}

export class Button extends Schema.AttributeSchema<Button_Params> {
    static className = "Button";
    private static _tagsByTag: Schema.TagsByTag = {"button":"<button>","input":"<input>","div":"<div>, <span>","span":"<div>, <span>"};
    private static _allParamsByTag = Schema.AttributeSchema._assignTagNames({
        "<button>": {
            "title": {
                "class": "6",
                "param": {
                    "name": "title",
                    "attributes": [
                        {
                            "name": "title"
                        }
                    ]
                }
            },
            "describedBy": {
                "class": "7",
                "param": {
                    "name": "describedBy",
                    "attributes": [
                        {
                            "name": "aria-describedby"
                        }
                    ]
                }
            },
            "hasPopup": {
                "class": "8",
                "param": {
                    "name": "hasPopup",
                    "attributes": [
                        {
                            "name": "aria-haspopup",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": [
                                        "true",
                                        "menu"
                                    ]
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "isExpanded": {
                "class": "9",
                "param": {
                    "name": "isExpanded",
                    "attributes": [
                        {
                            "name": "aria-expanded",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "isPressed": {
                "class": "10",
                "param": {
                    "name": "isPressed",
                    "attributes": [
                        {
                            "name": "aria-pressed",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "label": {
                "class": "11",
                "param": {
                    "name": "label",
                    "attributes": [
                        {
                            "name": "aria-label"
                        }
                    ]
                }
            },
            "labelledBy": {
                "class": "11",
                "param": {
                    "name": "labelledBy",
                    "attributes": [
                        {
                            "name": "aria-labelledby"
                        }
                    ]
                }
            },
            "tabbable": {
                "class": "12",
                "param": {
                    "name": "tabbable",
                    "attributes": [
                        {
                            "name": "tabindex",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "0"
                                },
                                {
                                    "parameter": false,
                                    "attribute": "-1"
                                }
                            ]
                        }
                    ]
                }
            },
            "disabled": {
                "class": "13",
                "param": {
                    "name": "disabled",
                    "attributes": [
                        {
                            "name": "disabled",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": true
                                },
                                {
                                    "parameter": false,
                                    "attribute": false
                                }
                            ]
                        },
                        {
                            "name": "aria-disabled",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": "false"
                                }
                            ],
                            "optional": true
                        }
                    ]
                }
            }
        },
        "<input>": {
            "title": {
                "class": "6",
                "param": {
                    "name": "title",
                    "attributes": [
                        {
                            "name": "title"
                        }
                    ]
                }
            },
            "describedBy": {
                "class": "7",
                "param": {
                    "name": "describedBy",
                    "attributes": [
                        {
                            "name": "aria-describedby"
                        }
                    ]
                }
            },
            "hasPopup": {
                "class": "8",
                "param": {
                    "name": "hasPopup",
                    "attributes": [
                        {
                            "name": "aria-haspopup",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": [
                                        "true",
                                        "menu"
                                    ]
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "isExpanded": {
                "class": "9",
                "param": {
                    "name": "isExpanded",
                    "attributes": [
                        {
                            "name": "aria-expanded",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "isPressed": {
                "class": "10",
                "param": {
                    "name": "isPressed",
                    "attributes": [
                        {
                            "name": "aria-pressed",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "label": {
                "class": "14",
                "param": {
                    "name": "label",
                    "attributes": [
                        {
                            "name": "aria-label"
                        }
                    ]
                }
            },
            "labelledBy": {
                "class": "14",
                "param": {
                    "name": "labelledBy",
                    "attributes": [
                        {
                            "name": "aria-labelledby"
                        }
                    ]
                }
            },
            "tabbable": {
                "class": "15",
                "param": {
                    "name": "tabbable",
                    "attributes": [
                        {
                            "name": "tabindex",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "0"
                                },
                                {
                                    "parameter": false,
                                    "attribute": "-1"
                                }
                            ]
                        }
                    ]
                }
            },
            "disabled": {
                "class": "16",
                "param": {
                    "name": "disabled",
                    "attributes": [
                        {
                            "name": "disabled",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": true
                                },
                                {
                                    "parameter": false,
                                    "attribute": false
                                }
                            ]
                        },
                        {
                            "name": "aria-disabled",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": "false"
                                }
                            ],
                            "optional": true
                        }
                    ]
                }
            }
        },
        "<div>, <span>": {
            "title": {
                "class": "6",
                "param": {
                    "name": "title",
                    "attributes": [
                        {
                            "name": "title"
                        }
                    ]
                }
            },
            "describedBy": {
                "class": "7",
                "param": {
                    "name": "describedBy",
                    "attributes": [
                        {
                            "name": "aria-describedby"
                        }
                    ]
                }
            },
            "hasPopup": {
                "class": "8",
                "param": {
                    "name": "hasPopup",
                    "attributes": [
                        {
                            "name": "aria-haspopup",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": [
                                        "true",
                                        "menu"
                                    ]
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "isExpanded": {
                "class": "9",
                "param": {
                    "name": "isExpanded",
                    "attributes": [
                        {
                            "name": "aria-expanded",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "isPressed": {
                "class": "10",
                "param": {
                    "name": "isPressed",
                    "attributes": [
                        {
                            "name": "aria-pressed",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "label": {
                "class": "17",
                "param": {
                    "name": "label",
                    "attributes": [
                        {
                            "name": "aria-label"
                        }
                    ]
                }
            },
            "labelledBy": {
                "class": "17",
                "param": {
                    "name": "labelledBy",
                    "attributes": [
                        {
                            "name": "aria-labelledby"
                        }
                    ]
                }
            },
            "tabbable": {
                "class": "18",
                "param": {
                    "name": "tabbable",
                    "attributes": [
                        {
                            "name": "tabindex",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "0"
                                },
                                {
                                    "parameter": false,
                                    "attribute": "-1"
                                }
                            ]
                        }
                    ]
                }
            },
            "disabled": {
                "class": "19",
                "param": {
                    "name": "disabled",
                    "attributes": [
                        {
                            "name": "aria-disabled",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "disabled",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": true
                                },
                                {
                                    "parameter": false,
                                    "attribute": false
                                }
                            ],
                            "optional": true
                        }
                    ]
                }
            }
        }
    }, Button._tagsByTag);
    private static _attrToParamByTag = Schema.AttributeSchema._assignTagNames({
        "<button>": {
            "title": "title",
            "aria-describedby": "describedBy",
            "aria-haspopup": "hasPopup",
            "aria-expanded": "isExpanded",
            "aria-pressed": "isPressed",
            "aria-label": "label",
            "aria-labelledby": "labelledBy",
            "tabindex": "tabbable",
            "disabled": "disabled",
            "aria-disabled": "disabled"
        },
        "<input>": {
            "title": "title",
            "aria-describedby": "describedBy",
            "aria-haspopup": "hasPopup",
            "aria-expanded": "isExpanded",
            "aria-pressed": "isPressed",
            "aria-label": "label",
            "aria-labelledby": "labelledBy",
            "tabindex": "tabbable",
            "disabled": "disabled",
            "aria-disabled": "disabled"
        },
        "<div>, <span>": {
            "title": "title",
            "aria-describedby": "describedBy",
            "aria-haspopup": "hasPopup",
            "aria-expanded": "isExpanded",
            "aria-pressed": "isPressed",
            "aria-label": "label",
            "aria-labelledby": "labelledBy",
            "tabindex": "tabbable",
            "aria-disabled": "disabled",
            "disabled": "disabled"
        }
    }, Button._tagsByTag);
    private static _paramToAttrByTag = Schema.AttributeSchema._assignTagNames({
        "<button>": {
            "title": "title",
            "describedBy": "aria-describedby",
            "hasPopup": "aria-haspopup",
            "isExpanded": "aria-expanded",
            "isPressed": "aria-pressed",
            "label": "aria-label",
            "labelledBy": "aria-labelledby",
            "tabbable": "tabindex",
            "disabled": "aria-disabled"
        },
        "<input>": {
            "title": "title",
            "describedBy": "aria-describedby",
            "hasPopup": "aria-haspopup",
            "isExpanded": "aria-expanded",
            "isPressed": "aria-pressed",
            "label": "aria-label",
            "labelledBy": "aria-labelledby",
            "tabbable": "tabindex",
            "disabled": "aria-disabled"
        },
        "<div>, <span>": {
            "title": "title",
            "describedBy": "aria-describedby",
            "hasPopup": "aria-haspopup",
            "isExpanded": "aria-expanded",
            "isPressed": "aria-pressed",
            "label": "aria-label",
            "labelledBy": "aria-labelledby",
            "tabbable": "tabindex",
            "disabled": "disabled"
        }
    }, Button._tagsByTag);
    private static _nonParamAttrsByTag = Schema.AttributeSchema._assignTagNames({
        "<button>": {
            "role": {
                "class": "1",
                "attr": {
                    "name": "role",
                    "default": "button",
                    "value": {
                        "button": true
                    },
                    "optional": true
                }
            }
        },
        "<input>": {
            "type": {
                "class": "2",
                "attr": {
                    "name": "type",
                    "default": "button",
                    "value": {
                        "button": true,
                        "submit": true,
                        "reset": true
                    }
                }
            },
            "role": {
                "class": "3",
                "attr": {
                    "name": "role",
                    "default": "button",
                    "value": {
                        "button": true
                    },
                    "optional": true
                }
            }
        },
        "<div>, <span>": {
            "role": {
                "class": "4",
                "attr": {
                    "name": "role",
                    "default": "button",
                    "value": {
                        "button": true
                    }
                }
            },
            "tabindex": {
                "class": "5",
                "attr": {
                    "name": "tabindex",
                    "default": "0",
                    "value": {
                        "0": true,
                        "-1": true
                    }
                }
            }
        }
    }, Button._tagsByTag);
    private static _mandatoryParams = {};

    protected _className = Button.className;
    protected _allParamsByTag = Button._allParamsByTag;
    protected _attrToParamByTag = Button._attrToParamByTag;
    protected _mandatoryParams = Button._mandatoryParams;
    protected _nonParamAttrsByTag = Button._nonParamAttrsByTag;

    constructor(tagName: string, params: Button_Params) {
        super(tagName, params);

        if (process.env.NODE_ENV !== 'production') {
            const classConstraints: Schema.Constraint[] = [
                {
                    "xpath": "not(boolean((.//*[@role and @role != 'none' and @role != 'presentation'] | .//a | .//area | .//button | .//input | .//object | .//select | .//textarea)[not(ancestor-or-self::*/@aria-hidden = 'true')]))",
                    "description": "Element cannot contain other accessible elements"
                }
            ];

            const tagConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({}, Button._tagsByTag)[tagName];

            const paramConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({
                "<button>": {
                    "title": [
                        {
                            "xpath": "normalize-space(@title) != ''",
                            "description": "title attribute value cannot be empty"
                        },
                        {
                            "js": "equalsToAccessibilityLabelIfAny",
                            "description": "In order to not confuse the users, the title attribute value should be equal to the accessibility label value"
                        }
                    ],
                    "describedBy": [
                        {
                            "js": "checkIdentifiers",
                            "description": "Value must be space-separated list of existing element identifiers"
                        }
                    ],
                    "label": [
                        {
                            "xpath": "normalize-space(@aria-label) != ''",
                            "description": "aria-label attribute value cannot be empty"
                        }
                    ],
                    "labelledBy": [
                        {
                            "js": "checkIdentifiers",
                            "description": "Value must be space-separated list of existing element identifiers"
                        }
                    ]
                },
                "<input>": {
                    "title": [
                        {
                            "xpath": "normalize-space(@title) != ''",
                            "description": "title attribute value cannot be empty"
                        },
                        {
                            "js": "equalsToAccessibilityLabelIfAny",
                            "description": "In order to not confuse the users, the title attribute value should be equal to the accessibility label value"
                        }
                    ],
                    "describedBy": [
                        {
                            "js": "checkIdentifiers",
                            "description": "Value must be space-separated list of existing element identifiers"
                        }
                    ],
                    "label": [
                        {
                            "xpath": "normalize-space(@aria-label) != ''",
                            "description": "aria-label attribute value cannot be empty"
                        }
                    ],
                    "labelledBy": [
                        {
                            "js": "checkIdentifiers",
                            "description": "Value must be space-separated list of existing element identifiers"
                        }
                    ]
                },
                "<div>, <span>": {
                    "title": [
                        {
                            "xpath": "normalize-space(@title) != ''",
                            "description": "title attribute value cannot be empty"
                        },
                        {
                            "js": "equalsToAccessibilityLabelIfAny",
                            "description": "In order to not confuse the users, the title attribute value should be equal to the accessibility label value"
                        }
                    ],
                    "describedBy": [
                        {
                            "js": "checkIdentifiers",
                            "description": "Value must be space-separated list of existing element identifiers"
                        }
                    ],
                    "label": [
                        {
                            "xpath": "normalize-space(@aria-label) != ''",
                            "description": "aria-label attribute value cannot be empty"
                        }
                    ],
                    "labelledBy": [
                        {
                            "js": "checkIdentifiers",
                            "description": "Value must be space-separated list of existing element identifiers"
                        }
                    ]
                }
            }, Button._tagsByTag)[tagName];

            const paramOptionalConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({
                "<button>": {
                    "label, labelledBy": [
                        {
                            "xpath": "boolean(@title and @title != '') or boolean(.//text()[normalize-space(.) != ''])",
                            "description": "Element must contain text nodes or title attribute"
                        }
                    ]
                },
                "<input>": {
                    "label, labelledBy": [
                        {
                            "xpath": "normalize-space(@value) != ''",
                            "description": "Element must contain value attribute"
                        }
                    ]
                },
                "<div>, <span>": {
                    "label, labelledBy": [
                        {
                            "xpath": "boolean(@title and @title != '') or boolean(.//text()[normalize-space(.) != ''])",
                            "description": "Element must contain text nodes or title attribute"
                        }
                    ]
                }
            }, Button._tagsByTag)[tagName];

            this.getConstraints = () => {
                const constraints: Schema.ParamConstraint[] = classConstraints.slice(0);

                if (tagConstraints) {
                    Array.prototype.push.apply(constraints, tagConstraints);
                }

                for (let paramName of Object.keys(paramConstraints)) {
                    if (paramName in this._params) {
                        Array.prototype.push.apply(constraints, paramConstraints[paramName].map(c => {
                            return { ...c, name: paramName, value: this._params[paramName as keyof Button_Params] };
                        }));
                    }
                }

                for (let paramName of Object.keys(paramOptionalConstraints)) {
                    const paramNames = paramName.split(', ');
                    const paramNamesText = paramNames.map(p => `'${ p }'`).join(' or ');

                    if (!(paramNames.some(n => n in this._params))) {
                        Array.prototype.push.apply(
                            constraints,
                            paramOptionalConstraints[paramName].map(c => { return { ...c, param: paramNamesText }; })
                        );
                    }
                }

                return constraints;
            };
        }
    }

    static fromAttributes(tagName: string, attributes: HTMLElementAttributes): Button {
        const pd = Schema.AttributeSchema._getParamsFromAttributes<Button_Params>(
            tagName,
            attributes,
            Button.className,
            Button._allParamsByTag,
            Button._attrToParamByTag,
            Button._paramToAttrByTag,
            Button._mandatoryParams,
            Button._nonParamAttrsByTag
        );

        const instance = new Button(tagName, pd.params);

        instance._setDefaults(pd.defaults);

        return instance;
    }
}

if (process.env.NODE_ENV !== 'production') {
    Button.assume = function(tagName: string, attributes: HTMLElementAttributes): Schema.AssumptionSpecificity | undefined {
        const assumptions: Schema.ClassAssumption[] = [
            {
                "tag": "button"
            },
            {
                "tag": "div",
                "attributes": [
                    {
                        "name": "role",
                        "value": "button"
                    }
                ]
            }
        ];

        for (let a of assumptions) {
            let tagMatch = false;
            let attributeMatch = 0;

            if ('tag' in a) {
                if (a.tag !== tagName) {
                    continue;
                }

                tagMatch = true;
            }

            if ('attributes' in a) {
                for (let attr of a.attributes) {
                    if (!(attr.name in attributes) || (attributes[attr.name] !== attr.value)) {
                        attributeMatch = 0;
                        break;
                    }

                    attributeMatch++;
                }

                if (attributeMatch === 0) {
                    continue;
                }
            } else if (!tagMatch) {
                continue;
            }

            return { tag: tagMatch, attributes: attributeMatch };
        }

        return undefined;
    };
}

export type LoadingButton_Params = {
    label?: string;
    labelledBy?: never;
    title?: string;
    describedBy?: string;
    hasPopup?: true | false;
    isExpanded?: true | false;
    isPressed?: true | false;
    tabbable?: true | false;
    disabled?: true | false;
} | {
    label?: never;
    labelledBy?: string;
    title?: string;
    describedBy?: string;
    hasPopup?: true | false;
    isExpanded?: true | false;
    isPressed?: true | false;
    tabbable?: true | false;
    disabled?: true | false;
}

export class LoadingButton extends Schema.AttributeSchema<LoadingButton_Params> {
    static className = "LoadingButton";
    private static _tagsByTag: Schema.TagsByTag = {"button":"<button>","input":"<input>","div":"<div>, <span>","span":"<div>, <span>"};
    private static _allParamsByTag = Schema.AttributeSchema._assignTagNames({
        "<button>": {
            "title": {
                "class": "6",
                "param": {
                    "name": "title",
                    "attributes": [
                        {
                            "name": "title"
                        }
                    ]
                }
            },
            "describedBy": {
                "class": "7",
                "param": {
                    "name": "describedBy",
                    "attributes": [
                        {
                            "name": "aria-describedby"
                        }
                    ]
                }
            },
            "hasPopup": {
                "class": "8",
                "param": {
                    "name": "hasPopup",
                    "attributes": [
                        {
                            "name": "aria-haspopup",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": [
                                        "true",
                                        "menu"
                                    ]
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "isExpanded": {
                "class": "9",
                "param": {
                    "name": "isExpanded",
                    "attributes": [
                        {
                            "name": "aria-expanded",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "isPressed": {
                "class": "10",
                "param": {
                    "name": "isPressed",
                    "attributes": [
                        {
                            "name": "aria-pressed",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "label": {
                "class": "11",
                "param": {
                    "name": "label",
                    "attributes": [
                        {
                            "name": "aria-label"
                        }
                    ]
                }
            },
            "labelledBy": {
                "class": "11",
                "param": {
                    "name": "labelledBy",
                    "attributes": [
                        {
                            "name": "aria-labelledby"
                        }
                    ]
                }
            },
            "tabbable": {
                "class": "12",
                "param": {
                    "name": "tabbable",
                    "attributes": [
                        {
                            "name": "tabindex",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "0"
                                },
                                {
                                    "parameter": false,
                                    "attribute": "-1"
                                }
                            ]
                        }
                    ]
                }
            },
            "disabled": {
                "class": "13",
                "param": {
                    "name": "disabled",
                    "attributes": [
                        {
                            "name": "aria-disabled",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            }
        },
        "<input>": {
            "title": {
                "class": "6",
                "param": {
                    "name": "title",
                    "attributes": [
                        {
                            "name": "title"
                        }
                    ]
                }
            },
            "describedBy": {
                "class": "7",
                "param": {
                    "name": "describedBy",
                    "attributes": [
                        {
                            "name": "aria-describedby"
                        }
                    ]
                }
            },
            "hasPopup": {
                "class": "8",
                "param": {
                    "name": "hasPopup",
                    "attributes": [
                        {
                            "name": "aria-haspopup",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": [
                                        "true",
                                        "menu"
                                    ]
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "isExpanded": {
                "class": "9",
                "param": {
                    "name": "isExpanded",
                    "attributes": [
                        {
                            "name": "aria-expanded",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "isPressed": {
                "class": "10",
                "param": {
                    "name": "isPressed",
                    "attributes": [
                        {
                            "name": "aria-pressed",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "label": {
                "class": "14",
                "param": {
                    "name": "label",
                    "attributes": [
                        {
                            "name": "aria-label"
                        }
                    ]
                }
            },
            "labelledBy": {
                "class": "14",
                "param": {
                    "name": "labelledBy",
                    "attributes": [
                        {
                            "name": "aria-labelledby"
                        }
                    ]
                }
            },
            "tabbable": {
                "class": "15",
                "param": {
                    "name": "tabbable",
                    "attributes": [
                        {
                            "name": "tabindex",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "0"
                                },
                                {
                                    "parameter": false,
                                    "attribute": "-1"
                                }
                            ]
                        }
                    ]
                }
            },
            "disabled": {
                "class": "16",
                "param": {
                    "name": "disabled",
                    "attributes": [
                        {
                            "name": "disabled",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": true
                                },
                                {
                                    "parameter": false,
                                    "attribute": false
                                }
                            ]
                        },
                        {
                            "name": "aria-disabled",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": "false"
                                }
                            ],
                            "optional": true
                        }
                    ]
                }
            }
        },
        "<div>, <span>": {
            "title": {
                "class": "6",
                "param": {
                    "name": "title",
                    "attributes": [
                        {
                            "name": "title"
                        }
                    ]
                }
            },
            "describedBy": {
                "class": "7",
                "param": {
                    "name": "describedBy",
                    "attributes": [
                        {
                            "name": "aria-describedby"
                        }
                    ]
                }
            },
            "hasPopup": {
                "class": "8",
                "param": {
                    "name": "hasPopup",
                    "attributes": [
                        {
                            "name": "aria-haspopup",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": [
                                        "true",
                                        "menu"
                                    ]
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "isExpanded": {
                "class": "9",
                "param": {
                    "name": "isExpanded",
                    "attributes": [
                        {
                            "name": "aria-expanded",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "isPressed": {
                "class": "10",
                "param": {
                    "name": "isPressed",
                    "attributes": [
                        {
                            "name": "aria-pressed",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "label": {
                "class": "17",
                "param": {
                    "name": "label",
                    "attributes": [
                        {
                            "name": "aria-label"
                        }
                    ]
                }
            },
            "labelledBy": {
                "class": "17",
                "param": {
                    "name": "labelledBy",
                    "attributes": [
                        {
                            "name": "aria-labelledby"
                        }
                    ]
                }
            },
            "tabbable": {
                "class": "18",
                "param": {
                    "name": "tabbable",
                    "attributes": [
                        {
                            "name": "tabindex",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "0"
                                },
                                {
                                    "parameter": false,
                                    "attribute": "-1"
                                }
                            ]
                        }
                    ]
                }
            },
            "disabled": {
                "class": "19",
                "param": {
                    "name": "disabled",
                    "attributes": [
                        {
                            "name": "aria-disabled",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "disabled",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": true
                                },
                                {
                                    "parameter": false,
                                    "attribute": false
                                }
                            ],
                            "optional": true
                        }
                    ]
                }
            }
        }
    }, LoadingButton._tagsByTag);
    private static _attrToParamByTag = Schema.AttributeSchema._assignTagNames({
        "<button>": {
            "title": "title",
            "aria-describedby": "describedBy",
            "aria-haspopup": "hasPopup",
            "aria-expanded": "isExpanded",
            "aria-pressed": "isPressed",
            "aria-label": "label",
            "aria-labelledby": "labelledBy",
            "tabindex": "tabbable",
            "aria-disabled": "disabled"
        },
        "<input>": {
            "title": "title",
            "aria-describedby": "describedBy",
            "aria-haspopup": "hasPopup",
            "aria-expanded": "isExpanded",
            "aria-pressed": "isPressed",
            "aria-label": "label",
            "aria-labelledby": "labelledBy",
            "tabindex": "tabbable",
            "disabled": "disabled",
            "aria-disabled": "disabled"
        },
        "<div>, <span>": {
            "title": "title",
            "aria-describedby": "describedBy",
            "aria-haspopup": "hasPopup",
            "aria-expanded": "isExpanded",
            "aria-pressed": "isPressed",
            "aria-label": "label",
            "aria-labelledby": "labelledBy",
            "tabindex": "tabbable",
            "aria-disabled": "disabled",
            "disabled": "disabled"
        }
    }, LoadingButton._tagsByTag);
    private static _paramToAttrByTag = Schema.AttributeSchema._assignTagNames({
        "<button>": {
            "title": "title",
            "describedBy": "aria-describedby",
            "hasPopup": "aria-haspopup",
            "isExpanded": "aria-expanded",
            "isPressed": "aria-pressed",
            "label": "aria-label",
            "labelledBy": "aria-labelledby",
            "tabbable": "tabindex",
            "disabled": "aria-disabled"
        },
        "<input>": {
            "title": "title",
            "describedBy": "aria-describedby",
            "hasPopup": "aria-haspopup",
            "isExpanded": "aria-expanded",
            "isPressed": "aria-pressed",
            "label": "aria-label",
            "labelledBy": "aria-labelledby",
            "tabbable": "tabindex",
            "disabled": "aria-disabled"
        },
        "<div>, <span>": {
            "title": "title",
            "describedBy": "aria-describedby",
            "hasPopup": "aria-haspopup",
            "isExpanded": "aria-expanded",
            "isPressed": "aria-pressed",
            "label": "aria-label",
            "labelledBy": "aria-labelledby",
            "tabbable": "tabindex",
            "disabled": "disabled"
        }
    }, LoadingButton._tagsByTag);
    private static _nonParamAttrsByTag = Schema.AttributeSchema._assignTagNames({
        "<button>": {
            "role": {
                "class": "1",
                "attr": {
                    "name": "role",
                    "default": "button",
                    "value": {
                        "button": true
                    },
                    "optional": true
                }
            }
        },
        "<input>": {
            "type": {
                "class": "2",
                "attr": {
                    "name": "type",
                    "default": "button",
                    "value": {
                        "button": true,
                        "submit": true,
                        "reset": true
                    }
                }
            },
            "role": {
                "class": "3",
                "attr": {
                    "name": "role",
                    "default": "button",
                    "value": {
                        "button": true
                    },
                    "optional": true
                }
            }
        },
        "<div>, <span>": {
            "role": {
                "class": "4",
                "attr": {
                    "name": "role",
                    "default": "button",
                    "value": {
                        "button": true
                    }
                }
            },
            "tabindex": {
                "class": "5",
                "attr": {
                    "name": "tabindex",
                    "default": "0",
                    "value": {
                        "0": true,
                        "-1": true
                    }
                }
            }
        }
    }, LoadingButton._tagsByTag);
    private static _mandatoryParams = {};

    protected _className = LoadingButton.className;
    protected _allParamsByTag = LoadingButton._allParamsByTag;
    protected _attrToParamByTag = LoadingButton._attrToParamByTag;
    protected _mandatoryParams = LoadingButton._mandatoryParams;
    protected _nonParamAttrsByTag = LoadingButton._nonParamAttrsByTag;

    constructor(tagName: string, params: LoadingButton_Params) {
        super(tagName, params);

        if (process.env.NODE_ENV !== 'production') {
            const classConstraints: Schema.Constraint[] = [
                {
                    "xpath": "not(boolean((.//*[@role and @role != 'none' and @role != 'presentation'] | .//a | .//area | .//button | .//input | .//object | .//select | .//textarea)[not(ancestor-or-self::*/@aria-hidden = 'true')]))",
                    "description": "Element cannot contain other accessible elements"
                }
            ];

            const tagConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({}, LoadingButton._tagsByTag)[tagName];

            const paramConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({
                "<button>": {
                    "title": [
                        {
                            "xpath": "normalize-space(@title) != ''",
                            "description": "title attribute value cannot be empty"
                        },
                        {
                            "js": "equalsToAccessibilityLabelIfAny",
                            "description": "In order to not confuse the users, the title attribute value should be equal to the accessibility label value"
                        }
                    ],
                    "describedBy": [
                        {
                            "js": "checkIdentifiers",
                            "description": "Value must be space-separated list of existing element identifiers"
                        }
                    ],
                    "label": [
                        {
                            "xpath": "normalize-space(@aria-label) != ''",
                            "description": "aria-label attribute value cannot be empty"
                        }
                    ],
                    "labelledBy": [
                        {
                            "js": "checkIdentifiers",
                            "description": "Value must be space-separated list of existing element identifiers"
                        }
                    ]
                },
                "<input>": {
                    "title": [
                        {
                            "xpath": "normalize-space(@title) != ''",
                            "description": "title attribute value cannot be empty"
                        },
                        {
                            "js": "equalsToAccessibilityLabelIfAny",
                            "description": "In order to not confuse the users, the title attribute value should be equal to the accessibility label value"
                        }
                    ],
                    "describedBy": [
                        {
                            "js": "checkIdentifiers",
                            "description": "Value must be space-separated list of existing element identifiers"
                        }
                    ],
                    "label": [
                        {
                            "xpath": "normalize-space(@aria-label) != ''",
                            "description": "aria-label attribute value cannot be empty"
                        }
                    ],
                    "labelledBy": [
                        {
                            "js": "checkIdentifiers",
                            "description": "Value must be space-separated list of existing element identifiers"
                        }
                    ]
                },
                "<div>, <span>": {
                    "title": [
                        {
                            "xpath": "normalize-space(@title) != ''",
                            "description": "title attribute value cannot be empty"
                        },
                        {
                            "js": "equalsToAccessibilityLabelIfAny",
                            "description": "In order to not confuse the users, the title attribute value should be equal to the accessibility label value"
                        }
                    ],
                    "describedBy": [
                        {
                            "js": "checkIdentifiers",
                            "description": "Value must be space-separated list of existing element identifiers"
                        }
                    ],
                    "label": [
                        {
                            "xpath": "normalize-space(@aria-label) != ''",
                            "description": "aria-label attribute value cannot be empty"
                        }
                    ],
                    "labelledBy": [
                        {
                            "js": "checkIdentifiers",
                            "description": "Value must be space-separated list of existing element identifiers"
                        }
                    ]
                }
            }, LoadingButton._tagsByTag)[tagName];

            const paramOptionalConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({
                "<button>": {
                    "label, labelledBy": [
                        {
                            "xpath": "boolean(@title and @title != '') or boolean(.//text()[normalize-space(.) != ''])",
                            "description": "Element must contain text nodes or title attribute"
                        }
                    ]
                },
                "<input>": {
                    "label, labelledBy": [
                        {
                            "xpath": "normalize-space(@value) != ''",
                            "description": "Element must contain value attribute"
                        }
                    ]
                },
                "<div>, <span>": {
                    "label, labelledBy": [
                        {
                            "xpath": "boolean(@title and @title != '') or boolean(.//text()[normalize-space(.) != ''])",
                            "description": "Element must contain text nodes or title attribute"
                        }
                    ]
                }
            }, LoadingButton._tagsByTag)[tagName];

            this.getConstraints = () => {
                const constraints: Schema.ParamConstraint[] = classConstraints.slice(0);

                if (tagConstraints) {
                    Array.prototype.push.apply(constraints, tagConstraints);
                }

                for (let paramName of Object.keys(paramConstraints)) {
                    if (paramName in this._params) {
                        Array.prototype.push.apply(constraints, paramConstraints[paramName].map(c => {
                            return { ...c, name: paramName, value: this._params[paramName as keyof LoadingButton_Params] };
                        }));
                    }
                }

                for (let paramName of Object.keys(paramOptionalConstraints)) {
                    const paramNames = paramName.split(', ');
                    const paramNamesText = paramNames.map(p => `'${ p }'`).join(' or ');

                    if (!(paramNames.some(n => n in this._params))) {
                        Array.prototype.push.apply(
                            constraints,
                            paramOptionalConstraints[paramName].map(c => { return { ...c, param: paramNamesText }; })
                        );
                    }
                }

                return constraints;
            };
        }
    }

    static fromAttributes(tagName: string, attributes: HTMLElementAttributes): LoadingButton {
        const pd = Schema.AttributeSchema._getParamsFromAttributes<LoadingButton_Params>(
            tagName,
            attributes,
            LoadingButton.className,
            LoadingButton._allParamsByTag,
            LoadingButton._attrToParamByTag,
            LoadingButton._paramToAttrByTag,
            LoadingButton._mandatoryParams,
            LoadingButton._nonParamAttrsByTag
        );

        const instance = new LoadingButton(tagName, pd.params);

        instance._setDefaults(pd.defaults);

        return instance;
    }
}


export type PopupButton_Params = {
    label?: string;
    labelledBy?: never;
    title?: string;
    describedBy?: string;
    isExpanded?: true | false;
    isPressed?: true | false;
    tabbable?: true | false;
    disabled?: true | false;
} | {
    label?: never;
    labelledBy?: string;
    title?: string;
    describedBy?: string;
    isExpanded?: true | false;
    isPressed?: true | false;
    tabbable?: true | false;
    disabled?: true | false;
}

export class PopupButton extends Schema.AttributeSchema<PopupButton_Params> {
    static className = "PopupButton";
    private static _tagsByTag: Schema.TagsByTag = {"button":"<button>","input":"<input>","div":"<div>, <span>","span":"<div>, <span>"};
    private static _allParamsByTag = Schema.AttributeSchema._assignTagNames({
        "<button>": {
            "title": {
                "class": "9",
                "param": {
                    "name": "title",
                    "attributes": [
                        {
                            "name": "title"
                        }
                    ]
                }
            },
            "describedBy": {
                "class": "10",
                "param": {
                    "name": "describedBy",
                    "attributes": [
                        {
                            "name": "aria-describedby"
                        }
                    ]
                }
            },
            "isExpanded": {
                "class": "11",
                "param": {
                    "name": "isExpanded",
                    "attributes": [
                        {
                            "name": "aria-expanded",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "isPressed": {
                "class": "12",
                "param": {
                    "name": "isPressed",
                    "attributes": [
                        {
                            "name": "aria-pressed",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "label": {
                "class": "13",
                "param": {
                    "name": "label",
                    "attributes": [
                        {
                            "name": "aria-label"
                        }
                    ]
                }
            },
            "labelledBy": {
                "class": "13",
                "param": {
                    "name": "labelledBy",
                    "attributes": [
                        {
                            "name": "aria-labelledby"
                        }
                    ]
                }
            },
            "tabbable": {
                "class": "14",
                "param": {
                    "name": "tabbable",
                    "attributes": [
                        {
                            "name": "tabindex",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "0"
                                },
                                {
                                    "parameter": false,
                                    "attribute": "-1"
                                }
                            ]
                        }
                    ]
                }
            },
            "disabled": {
                "class": "15",
                "param": {
                    "name": "disabled",
                    "attributes": [
                        {
                            "name": "disabled",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": true
                                },
                                {
                                    "parameter": false,
                                    "attribute": false
                                }
                            ]
                        },
                        {
                            "name": "aria-disabled",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": "false"
                                }
                            ],
                            "optional": true
                        }
                    ]
                }
            }
        },
        "<input>": {
            "title": {
                "class": "9",
                "param": {
                    "name": "title",
                    "attributes": [
                        {
                            "name": "title"
                        }
                    ]
                }
            },
            "describedBy": {
                "class": "10",
                "param": {
                    "name": "describedBy",
                    "attributes": [
                        {
                            "name": "aria-describedby"
                        }
                    ]
                }
            },
            "isExpanded": {
                "class": "11",
                "param": {
                    "name": "isExpanded",
                    "attributes": [
                        {
                            "name": "aria-expanded",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "isPressed": {
                "class": "12",
                "param": {
                    "name": "isPressed",
                    "attributes": [
                        {
                            "name": "aria-pressed",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "label": {
                "class": "16",
                "param": {
                    "name": "label",
                    "attributes": [
                        {
                            "name": "aria-label"
                        }
                    ]
                }
            },
            "labelledBy": {
                "class": "16",
                "param": {
                    "name": "labelledBy",
                    "attributes": [
                        {
                            "name": "aria-labelledby"
                        }
                    ]
                }
            },
            "tabbable": {
                "class": "17",
                "param": {
                    "name": "tabbable",
                    "attributes": [
                        {
                            "name": "tabindex",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "0"
                                },
                                {
                                    "parameter": false,
                                    "attribute": "-1"
                                }
                            ]
                        }
                    ]
                }
            },
            "disabled": {
                "class": "18",
                "param": {
                    "name": "disabled",
                    "attributes": [
                        {
                            "name": "disabled",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": true
                                },
                                {
                                    "parameter": false,
                                    "attribute": false
                                }
                            ]
                        },
                        {
                            "name": "aria-disabled",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": "false"
                                }
                            ],
                            "optional": true
                        }
                    ]
                }
            }
        },
        "<div>, <span>": {
            "title": {
                "class": "9",
                "param": {
                    "name": "title",
                    "attributes": [
                        {
                            "name": "title"
                        }
                    ]
                }
            },
            "describedBy": {
                "class": "10",
                "param": {
                    "name": "describedBy",
                    "attributes": [
                        {
                            "name": "aria-describedby"
                        }
                    ]
                }
            },
            "isExpanded": {
                "class": "11",
                "param": {
                    "name": "isExpanded",
                    "attributes": [
                        {
                            "name": "aria-expanded",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "isPressed": {
                "class": "12",
                "param": {
                    "name": "isPressed",
                    "attributes": [
                        {
                            "name": "aria-pressed",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "label": {
                "class": "19",
                "param": {
                    "name": "label",
                    "attributes": [
                        {
                            "name": "aria-label"
                        }
                    ]
                }
            },
            "labelledBy": {
                "class": "19",
                "param": {
                    "name": "labelledBy",
                    "attributes": [
                        {
                            "name": "aria-labelledby"
                        }
                    ]
                }
            },
            "tabbable": {
                "class": "20",
                "param": {
                    "name": "tabbable",
                    "attributes": [
                        {
                            "name": "tabindex",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "0"
                                },
                                {
                                    "parameter": false,
                                    "attribute": "-1"
                                }
                            ]
                        }
                    ]
                }
            },
            "disabled": {
                "class": "21",
                "param": {
                    "name": "disabled",
                    "attributes": [
                        {
                            "name": "aria-disabled",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "disabled",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": true
                                },
                                {
                                    "parameter": false,
                                    "attribute": false
                                }
                            ],
                            "optional": true
                        }
                    ]
                }
            }
        }
    }, PopupButton._tagsByTag);
    private static _attrToParamByTag = Schema.AttributeSchema._assignTagNames({
        "<button>": {
            "title": "title",
            "aria-describedby": "describedBy",
            "aria-expanded": "isExpanded",
            "aria-pressed": "isPressed",
            "aria-label": "label",
            "aria-labelledby": "labelledBy",
            "tabindex": "tabbable",
            "disabled": "disabled",
            "aria-disabled": "disabled"
        },
        "<input>": {
            "title": "title",
            "aria-describedby": "describedBy",
            "aria-expanded": "isExpanded",
            "aria-pressed": "isPressed",
            "aria-label": "label",
            "aria-labelledby": "labelledBy",
            "tabindex": "tabbable",
            "disabled": "disabled",
            "aria-disabled": "disabled"
        },
        "<div>, <span>": {
            "title": "title",
            "aria-describedby": "describedBy",
            "aria-expanded": "isExpanded",
            "aria-pressed": "isPressed",
            "aria-label": "label",
            "aria-labelledby": "labelledBy",
            "tabindex": "tabbable",
            "aria-disabled": "disabled",
            "disabled": "disabled"
        }
    }, PopupButton._tagsByTag);
    private static _paramToAttrByTag = Schema.AttributeSchema._assignTagNames({
        "<button>": {
            "title": "title",
            "describedBy": "aria-describedby",
            "isExpanded": "aria-expanded",
            "isPressed": "aria-pressed",
            "label": "aria-label",
            "labelledBy": "aria-labelledby",
            "tabbable": "tabindex",
            "disabled": "aria-disabled"
        },
        "<input>": {
            "title": "title",
            "describedBy": "aria-describedby",
            "isExpanded": "aria-expanded",
            "isPressed": "aria-pressed",
            "label": "aria-label",
            "labelledBy": "aria-labelledby",
            "tabbable": "tabindex",
            "disabled": "aria-disabled"
        },
        "<div>, <span>": {
            "title": "title",
            "describedBy": "aria-describedby",
            "isExpanded": "aria-expanded",
            "isPressed": "aria-pressed",
            "label": "aria-label",
            "labelledBy": "aria-labelledby",
            "tabbable": "tabindex",
            "disabled": "disabled"
        }
    }, PopupButton._tagsByTag);
    private static _nonParamAttrsByTag = Schema.AttributeSchema._assignTagNames({
        "<button>": {
            "role": {
                "class": "1",
                "attr": {
                    "name": "role",
                    "default": "button",
                    "value": {
                        "button": true
                    },
                    "optional": true
                }
            },
            "aria-haspopup": {
                "class": "2",
                "attr": {
                    "name": "aria-haspopup",
                    "default": "true",
                    "value": {
                        "true": true
                    }
                }
            }
        },
        "<input>": {
            "type": {
                "class": "3",
                "attr": {
                    "name": "type",
                    "default": "button",
                    "value": {
                        "button": true,
                        "submit": true,
                        "reset": true
                    }
                }
            },
            "role": {
                "class": "4",
                "attr": {
                    "name": "role",
                    "default": "button",
                    "value": {
                        "button": true
                    },
                    "optional": true
                }
            },
            "aria-haspopup": {
                "class": "5",
                "attr": {
                    "name": "aria-haspopup",
                    "default": "true",
                    "value": {
                        "true": true
                    }
                }
            }
        },
        "<div>, <span>": {
            "role": {
                "class": "6",
                "attr": {
                    "name": "role",
                    "default": "button",
                    "value": {
                        "button": true
                    }
                }
            },
            "tabindex": {
                "class": "7",
                "attr": {
                    "name": "tabindex",
                    "default": "0",
                    "value": {
                        "0": true,
                        "-1": true
                    }
                }
            },
            "aria-haspopup": {
                "class": "8",
                "attr": {
                    "name": "aria-haspopup",
                    "default": "true",
                    "value": {
                        "true": true
                    }
                }
            }
        }
    }, PopupButton._tagsByTag);
    private static _mandatoryParams = {};

    protected _className = PopupButton.className;
    protected _allParamsByTag = PopupButton._allParamsByTag;
    protected _attrToParamByTag = PopupButton._attrToParamByTag;
    protected _mandatoryParams = PopupButton._mandatoryParams;
    protected _nonParamAttrsByTag = PopupButton._nonParamAttrsByTag;

    constructor(tagName: string, params: PopupButton_Params) {
        super(tagName, params);

        if (process.env.NODE_ENV !== 'production') {
            const classConstraints: Schema.Constraint[] = [
                {
                    "xpath": "not(boolean((.//*[@role and @role != 'none' and @role != 'presentation'] | .//a | .//area | .//button | .//input | .//object | .//select | .//textarea)[not(ancestor-or-self::*/@aria-hidden = 'true')]))",
                    "description": "Element cannot contain other accessible elements"
                }
            ];

            const tagConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({}, PopupButton._tagsByTag)[tagName];

            const paramConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({
                "<button>": {
                    "title": [
                        {
                            "xpath": "normalize-space(@title) != ''",
                            "description": "title attribute value cannot be empty"
                        },
                        {
                            "js": "equalsToAccessibilityLabelIfAny",
                            "description": "In order to not confuse the users, the title attribute value should be equal to the accessibility label value"
                        }
                    ],
                    "describedBy": [
                        {
                            "js": "checkIdentifiers",
                            "description": "Value must be space-separated list of existing element identifiers"
                        }
                    ],
                    "label": [
                        {
                            "xpath": "normalize-space(@aria-label) != ''",
                            "description": "aria-label attribute value cannot be empty"
                        }
                    ],
                    "labelledBy": [
                        {
                            "js": "checkIdentifiers",
                            "description": "Value must be space-separated list of existing element identifiers"
                        }
                    ]
                },
                "<input>": {
                    "title": [
                        {
                            "xpath": "normalize-space(@title) != ''",
                            "description": "title attribute value cannot be empty"
                        },
                        {
                            "js": "equalsToAccessibilityLabelIfAny",
                            "description": "In order to not confuse the users, the title attribute value should be equal to the accessibility label value"
                        }
                    ],
                    "describedBy": [
                        {
                            "js": "checkIdentifiers",
                            "description": "Value must be space-separated list of existing element identifiers"
                        }
                    ],
                    "label": [
                        {
                            "xpath": "normalize-space(@aria-label) != ''",
                            "description": "aria-label attribute value cannot be empty"
                        }
                    ],
                    "labelledBy": [
                        {
                            "js": "checkIdentifiers",
                            "description": "Value must be space-separated list of existing element identifiers"
                        }
                    ]
                },
                "<div>, <span>": {
                    "title": [
                        {
                            "xpath": "normalize-space(@title) != ''",
                            "description": "title attribute value cannot be empty"
                        },
                        {
                            "js": "equalsToAccessibilityLabelIfAny",
                            "description": "In order to not confuse the users, the title attribute value should be equal to the accessibility label value"
                        }
                    ],
                    "describedBy": [
                        {
                            "js": "checkIdentifiers",
                            "description": "Value must be space-separated list of existing element identifiers"
                        }
                    ],
                    "label": [
                        {
                            "xpath": "normalize-space(@aria-label) != ''",
                            "description": "aria-label attribute value cannot be empty"
                        }
                    ],
                    "labelledBy": [
                        {
                            "js": "checkIdentifiers",
                            "description": "Value must be space-separated list of existing element identifiers"
                        }
                    ]
                }
            }, PopupButton._tagsByTag)[tagName];

            const paramOptionalConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({
                "<button>": {
                    "label, labelledBy": [
                        {
                            "xpath": "boolean(@title and @title != '') or boolean(.//text()[normalize-space(.) != ''])",
                            "description": "Element must contain text nodes or title attribute"
                        }
                    ]
                },
                "<input>": {
                    "label, labelledBy": [
                        {
                            "xpath": "normalize-space(@value) != ''",
                            "description": "Element must contain value attribute"
                        }
                    ]
                },
                "<div>, <span>": {
                    "label, labelledBy": [
                        {
                            "xpath": "boolean(@title and @title != '') or boolean(.//text()[normalize-space(.) != ''])",
                            "description": "Element must contain text nodes or title attribute"
                        }
                    ]
                }
            }, PopupButton._tagsByTag)[tagName];

            this.getConstraints = () => {
                const constraints: Schema.ParamConstraint[] = classConstraints.slice(0);

                if (tagConstraints) {
                    Array.prototype.push.apply(constraints, tagConstraints);
                }

                for (let paramName of Object.keys(paramConstraints)) {
                    if (paramName in this._params) {
                        Array.prototype.push.apply(constraints, paramConstraints[paramName].map(c => {
                            return { ...c, name: paramName, value: this._params[paramName as keyof PopupButton_Params] };
                        }));
                    }
                }

                for (let paramName of Object.keys(paramOptionalConstraints)) {
                    const paramNames = paramName.split(', ');
                    const paramNamesText = paramNames.map(p => `'${ p }'`).join(' or ');

                    if (!(paramNames.some(n => n in this._params))) {
                        Array.prototype.push.apply(
                            constraints,
                            paramOptionalConstraints[paramName].map(c => { return { ...c, param: paramNamesText }; })
                        );
                    }
                }

                return constraints;
            };
        }
    }

    static fromAttributes(tagName: string, attributes: HTMLElementAttributes): PopupButton {
        const pd = Schema.AttributeSchema._getParamsFromAttributes<PopupButton_Params>(
            tagName,
            attributes,
            PopupButton.className,
            PopupButton._allParamsByTag,
            PopupButton._attrToParamByTag,
            PopupButton._paramToAttrByTag,
            PopupButton._mandatoryParams,
            PopupButton._nonParamAttrsByTag
        );

        const instance = new PopupButton(tagName, pd.params);

        instance._setDefaults(pd.defaults);

        return instance;
    }
}


export type ToolbarItem_Params = {
    label?: string;
    labelledBy?: never;
    title?: string;
    describedBy?: string;
    hasPopup?: true | false;
    isExpanded?: true | false;
    isPressed?: true | false;
    tabbable?: true | false;
    disabled?: true | false;
} | {
    label?: never;
    labelledBy?: string;
    title?: string;
    describedBy?: string;
    hasPopup?: true | false;
    isExpanded?: true | false;
    isPressed?: true | false;
    tabbable?: true | false;
    disabled?: true | false;
}

export class ToolbarItem extends Schema.AttributeSchema<ToolbarItem_Params> {
    static className = "ToolbarItem";
    private static _tagsByTag: Schema.TagsByTag = {"button":"<button>","input":"<input>","div":"<div>, <span>","span":"<div>, <span>"};
    private static _allParamsByTag = Schema.AttributeSchema._assignTagNames({
        "<button>": {
            "title": {
                "class": "6",
                "param": {
                    "name": "title",
                    "attributes": [
                        {
                            "name": "title"
                        }
                    ]
                }
            },
            "describedBy": {
                "class": "7",
                "param": {
                    "name": "describedBy",
                    "attributes": [
                        {
                            "name": "aria-describedby"
                        }
                    ]
                }
            },
            "hasPopup": {
                "class": "8",
                "param": {
                    "name": "hasPopup",
                    "attributes": [
                        {
                            "name": "aria-haspopup",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": [
                                        "true",
                                        "menu"
                                    ]
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "isExpanded": {
                "class": "9",
                "param": {
                    "name": "isExpanded",
                    "attributes": [
                        {
                            "name": "aria-expanded",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "isPressed": {
                "class": "10",
                "param": {
                    "name": "isPressed",
                    "attributes": [
                        {
                            "name": "aria-pressed",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "label": {
                "class": "11",
                "param": {
                    "name": "label",
                    "attributes": [
                        {
                            "name": "aria-label"
                        }
                    ]
                }
            },
            "labelledBy": {
                "class": "11",
                "param": {
                    "name": "labelledBy",
                    "attributes": [
                        {
                            "name": "aria-labelledby"
                        }
                    ]
                }
            },
            "tabbable": {
                "class": "12",
                "param": {
                    "name": "tabbable",
                    "attributes": [
                        {
                            "name": "tabindex",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "0"
                                },
                                {
                                    "parameter": false,
                                    "attribute": "-1"
                                }
                            ]
                        }
                    ]
                }
            },
            "disabled": {
                "class": "13",
                "param": {
                    "name": "disabled",
                    "attributes": [
                        {
                            "name": "disabled",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": true
                                },
                                {
                                    "parameter": false,
                                    "attribute": false
                                }
                            ]
                        },
                        {
                            "name": "aria-disabled",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": "false"
                                }
                            ],
                            "optional": true
                        }
                    ]
                }
            }
        },
        "<input>": {
            "title": {
                "class": "6",
                "param": {
                    "name": "title",
                    "attributes": [
                        {
                            "name": "title"
                        }
                    ]
                }
            },
            "describedBy": {
                "class": "7",
                "param": {
                    "name": "describedBy",
                    "attributes": [
                        {
                            "name": "aria-describedby"
                        }
                    ]
                }
            },
            "hasPopup": {
                "class": "8",
                "param": {
                    "name": "hasPopup",
                    "attributes": [
                        {
                            "name": "aria-haspopup",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": [
                                        "true",
                                        "menu"
                                    ]
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "isExpanded": {
                "class": "9",
                "param": {
                    "name": "isExpanded",
                    "attributes": [
                        {
                            "name": "aria-expanded",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "isPressed": {
                "class": "10",
                "param": {
                    "name": "isPressed",
                    "attributes": [
                        {
                            "name": "aria-pressed",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "label": {
                "class": "14",
                "param": {
                    "name": "label",
                    "attributes": [
                        {
                            "name": "aria-label"
                        }
                    ]
                }
            },
            "labelledBy": {
                "class": "14",
                "param": {
                    "name": "labelledBy",
                    "attributes": [
                        {
                            "name": "aria-labelledby"
                        }
                    ]
                }
            },
            "tabbable": {
                "class": "15",
                "param": {
                    "name": "tabbable",
                    "attributes": [
                        {
                            "name": "tabindex",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "0"
                                },
                                {
                                    "parameter": false,
                                    "attribute": "-1"
                                }
                            ]
                        }
                    ]
                }
            },
            "disabled": {
                "class": "16",
                "param": {
                    "name": "disabled",
                    "attributes": [
                        {
                            "name": "disabled",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": true
                                },
                                {
                                    "parameter": false,
                                    "attribute": false
                                }
                            ]
                        },
                        {
                            "name": "aria-disabled",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": "false"
                                }
                            ],
                            "optional": true
                        }
                    ]
                }
            }
        },
        "<div>, <span>": {
            "title": {
                "class": "6",
                "param": {
                    "name": "title",
                    "attributes": [
                        {
                            "name": "title"
                        }
                    ]
                }
            },
            "describedBy": {
                "class": "7",
                "param": {
                    "name": "describedBy",
                    "attributes": [
                        {
                            "name": "aria-describedby"
                        }
                    ]
                }
            },
            "hasPopup": {
                "class": "8",
                "param": {
                    "name": "hasPopup",
                    "attributes": [
                        {
                            "name": "aria-haspopup",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": [
                                        "true",
                                        "menu"
                                    ]
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "isExpanded": {
                "class": "9",
                "param": {
                    "name": "isExpanded",
                    "attributes": [
                        {
                            "name": "aria-expanded",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "isPressed": {
                "class": "10",
                "param": {
                    "name": "isPressed",
                    "attributes": [
                        {
                            "name": "aria-pressed",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "label": {
                "class": "17",
                "param": {
                    "name": "label",
                    "attributes": [
                        {
                            "name": "aria-label"
                        }
                    ]
                }
            },
            "labelledBy": {
                "class": "17",
                "param": {
                    "name": "labelledBy",
                    "attributes": [
                        {
                            "name": "aria-labelledby"
                        }
                    ]
                }
            },
            "tabbable": {
                "class": "18",
                "param": {
                    "name": "tabbable",
                    "attributes": [
                        {
                            "name": "tabindex",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "0"
                                },
                                {
                                    "parameter": false,
                                    "attribute": "-1"
                                }
                            ]
                        }
                    ]
                }
            },
            "disabled": {
                "class": "19",
                "param": {
                    "name": "disabled",
                    "attributes": [
                        {
                            "name": "aria-disabled",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "disabled",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": true
                                },
                                {
                                    "parameter": false,
                                    "attribute": false
                                }
                            ],
                            "optional": true
                        }
                    ]
                }
            }
        }
    }, ToolbarItem._tagsByTag);
    private static _attrToParamByTag = Schema.AttributeSchema._assignTagNames({
        "<button>": {
            "title": "title",
            "aria-describedby": "describedBy",
            "aria-haspopup": "hasPopup",
            "aria-expanded": "isExpanded",
            "aria-pressed": "isPressed",
            "aria-label": "label",
            "aria-labelledby": "labelledBy",
            "tabindex": "tabbable",
            "disabled": "disabled",
            "aria-disabled": "disabled"
        },
        "<input>": {
            "title": "title",
            "aria-describedby": "describedBy",
            "aria-haspopup": "hasPopup",
            "aria-expanded": "isExpanded",
            "aria-pressed": "isPressed",
            "aria-label": "label",
            "aria-labelledby": "labelledBy",
            "tabindex": "tabbable",
            "disabled": "disabled",
            "aria-disabled": "disabled"
        },
        "<div>, <span>": {
            "title": "title",
            "aria-describedby": "describedBy",
            "aria-haspopup": "hasPopup",
            "aria-expanded": "isExpanded",
            "aria-pressed": "isPressed",
            "aria-label": "label",
            "aria-labelledby": "labelledBy",
            "tabindex": "tabbable",
            "aria-disabled": "disabled",
            "disabled": "disabled"
        }
    }, ToolbarItem._tagsByTag);
    private static _paramToAttrByTag = Schema.AttributeSchema._assignTagNames({
        "<button>": {
            "title": "title",
            "describedBy": "aria-describedby",
            "hasPopup": "aria-haspopup",
            "isExpanded": "aria-expanded",
            "isPressed": "aria-pressed",
            "label": "aria-label",
            "labelledBy": "aria-labelledby",
            "tabbable": "tabindex",
            "disabled": "aria-disabled"
        },
        "<input>": {
            "title": "title",
            "describedBy": "aria-describedby",
            "hasPopup": "aria-haspopup",
            "isExpanded": "aria-expanded",
            "isPressed": "aria-pressed",
            "label": "aria-label",
            "labelledBy": "aria-labelledby",
            "tabbable": "tabindex",
            "disabled": "aria-disabled"
        },
        "<div>, <span>": {
            "title": "title",
            "describedBy": "aria-describedby",
            "hasPopup": "aria-haspopup",
            "isExpanded": "aria-expanded",
            "isPressed": "aria-pressed",
            "label": "aria-label",
            "labelledBy": "aria-labelledby",
            "tabbable": "tabindex",
            "disabled": "disabled"
        }
    }, ToolbarItem._tagsByTag);
    private static _nonParamAttrsByTag = Schema.AttributeSchema._assignTagNames({
        "<button>": {
            "role": {
                "class": "1",
                "attr": {
                    "name": "role",
                    "default": "button",
                    "value": {
                        "button": true
                    },
                    "optional": true
                }
            }
        },
        "<input>": {
            "type": {
                "class": "2",
                "attr": {
                    "name": "type",
                    "default": "button",
                    "value": {
                        "button": true,
                        "submit": true,
                        "reset": true
                    }
                }
            },
            "role": {
                "class": "3",
                "attr": {
                    "name": "role",
                    "default": "button",
                    "value": {
                        "button": true
                    },
                    "optional": true
                }
            }
        },
        "<div>, <span>": {
            "role": {
                "class": "4",
                "attr": {
                    "name": "role",
                    "default": "button",
                    "value": {
                        "button": true
                    }
                }
            },
            "tabindex": {
                "class": "5",
                "attr": {
                    "name": "tabindex",
                    "default": "0",
                    "value": {
                        "0": true,
                        "-1": true
                    }
                }
            }
        }
    }, ToolbarItem._tagsByTag);
    private static _mandatoryParams = {};

    protected _className = ToolbarItem.className;
    protected _allParamsByTag = ToolbarItem._allParamsByTag;
    protected _attrToParamByTag = ToolbarItem._attrToParamByTag;
    protected _mandatoryParams = ToolbarItem._mandatoryParams;
    protected _nonParamAttrsByTag = ToolbarItem._nonParamAttrsByTag;

    constructor(tagName: string, params: ToolbarItem_Params) {
        super(tagName, params);

        if (process.env.NODE_ENV !== 'production') {
            const classConstraints: Schema.Constraint[] = [
                {
                    "xpath": "not(boolean((.//*[@role and @role != 'none' and @role != 'presentation'] | .//a | .//area | .//button | .//input | .//object | .//select | .//textarea)[not(ancestor-or-self::*/@aria-hidden = 'true')]))",
                    "description": "Element cannot contain other accessible elements"
                }
            ];

            const tagConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({}, ToolbarItem._tagsByTag)[tagName];

            const paramConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({
                "<button>": {
                    "title": [
                        {
                            "xpath": "normalize-space(@title) != ''",
                            "description": "title attribute value cannot be empty"
                        },
                        {
                            "js": "equalsToAccessibilityLabelIfAny",
                            "description": "In order to not confuse the users, the title attribute value should be equal to the accessibility label value"
                        }
                    ],
                    "describedBy": [
                        {
                            "js": "checkIdentifiers",
                            "description": "Value must be space-separated list of existing element identifiers"
                        }
                    ],
                    "label": [
                        {
                            "xpath": "normalize-space(@aria-label) != ''",
                            "description": "aria-label attribute value cannot be empty"
                        }
                    ],
                    "labelledBy": [
                        {
                            "js": "checkIdentifiers",
                            "description": "Value must be space-separated list of existing element identifiers"
                        }
                    ]
                },
                "<input>": {
                    "title": [
                        {
                            "xpath": "normalize-space(@title) != ''",
                            "description": "title attribute value cannot be empty"
                        },
                        {
                            "js": "equalsToAccessibilityLabelIfAny",
                            "description": "In order to not confuse the users, the title attribute value should be equal to the accessibility label value"
                        }
                    ],
                    "describedBy": [
                        {
                            "js": "checkIdentifiers",
                            "description": "Value must be space-separated list of existing element identifiers"
                        }
                    ],
                    "label": [
                        {
                            "xpath": "normalize-space(@aria-label) != ''",
                            "description": "aria-label attribute value cannot be empty"
                        }
                    ],
                    "labelledBy": [
                        {
                            "js": "checkIdentifiers",
                            "description": "Value must be space-separated list of existing element identifiers"
                        }
                    ]
                },
                "<div>, <span>": {
                    "title": [
                        {
                            "xpath": "normalize-space(@title) != ''",
                            "description": "title attribute value cannot be empty"
                        },
                        {
                            "js": "equalsToAccessibilityLabelIfAny",
                            "description": "In order to not confuse the users, the title attribute value should be equal to the accessibility label value"
                        }
                    ],
                    "describedBy": [
                        {
                            "js": "checkIdentifiers",
                            "description": "Value must be space-separated list of existing element identifiers"
                        }
                    ],
                    "label": [
                        {
                            "xpath": "normalize-space(@aria-label) != ''",
                            "description": "aria-label attribute value cannot be empty"
                        }
                    ],
                    "labelledBy": [
                        {
                            "js": "checkIdentifiers",
                            "description": "Value must be space-separated list of existing element identifiers"
                        }
                    ]
                }
            }, ToolbarItem._tagsByTag)[tagName];

            const paramOptionalConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({
                "<button>": {
                    "label, labelledBy": [
                        {
                            "xpath": "boolean(@title and @title != '') or boolean(.//text()[normalize-space(.) != ''])",
                            "description": "Element must contain text nodes or title attribute"
                        }
                    ]
                },
                "<input>": {
                    "label, labelledBy": [
                        {
                            "xpath": "normalize-space(@value) != ''",
                            "description": "Element must contain value attribute"
                        }
                    ]
                },
                "<div>, <span>": {
                    "label, labelledBy": [
                        {
                            "xpath": "boolean(@title and @title != '') or boolean(.//text()[normalize-space(.) != ''])",
                            "description": "Element must contain text nodes or title attribute"
                        }
                    ]
                }
            }, ToolbarItem._tagsByTag)[tagName];

            this.getConstraints = () => {
                const constraints: Schema.ParamConstraint[] = classConstraints.slice(0);

                if (tagConstraints) {
                    Array.prototype.push.apply(constraints, tagConstraints);
                }

                for (let paramName of Object.keys(paramConstraints)) {
                    if (paramName in this._params) {
                        Array.prototype.push.apply(constraints, paramConstraints[paramName].map(c => {
                            return { ...c, name: paramName, value: this._params[paramName as keyof ToolbarItem_Params] };
                        }));
                    }
                }

                for (let paramName of Object.keys(paramOptionalConstraints)) {
                    const paramNames = paramName.split(', ');
                    const paramNamesText = paramNames.map(p => `'${ p }'`).join(' or ');

                    if (!(paramNames.some(n => n in this._params))) {
                        Array.prototype.push.apply(
                            constraints,
                            paramOptionalConstraints[paramName].map(c => { return { ...c, param: paramNamesText }; })
                        );
                    }
                }

                return constraints;
            };
        }
    }

    static fromAttributes(tagName: string, attributes: HTMLElementAttributes): ToolbarItem {
        const pd = Schema.AttributeSchema._getParamsFromAttributes<ToolbarItem_Params>(
            tagName,
            attributes,
            ToolbarItem.className,
            ToolbarItem._allParamsByTag,
            ToolbarItem._attrToParamByTag,
            ToolbarItem._paramToAttrByTag,
            ToolbarItem._mandatoryParams,
            ToolbarItem._nonParamAttrsByTag
        );

        const instance = new ToolbarItem(tagName, pd.params);

        instance._setDefaults(pd.defaults);

        return instance;
    }
}


export type Checkbox_Params = {
    label?: string;
    labelledBy?: never;
    title?: string;
    describedBy?: string;
    hasPopup?: true | false;
    isExpanded?: true | false;
    isPressed?: true | false;
    tabbable?: true | false;
    disabled?: true | false;
    checked?: true | false;
} | {
    label?: never;
    labelledBy?: string;
    title?: string;
    describedBy?: string;
    hasPopup?: true | false;
    isExpanded?: true | false;
    isPressed?: true | false;
    tabbable?: true | false;
    disabled?: true | false;
    checked?: true | false;
}

export class Checkbox extends Schema.AttributeSchema<Checkbox_Params> {
    static className = "Checkbox";
    private static _tagsByTag: Schema.TagsByTag = {"button":"<button>","input":"<input>","div":"<div>, <span>","span":"<div>, <span>"};
    private static _allParamsByTag = Schema.AttributeSchema._assignTagNames({
        "<button>": {
            "title": {
                "class": "6",
                "param": {
                    "name": "title",
                    "attributes": [
                        {
                            "name": "title"
                        }
                    ]
                }
            },
            "describedBy": {
                "class": "7",
                "param": {
                    "name": "describedBy",
                    "attributes": [
                        {
                            "name": "aria-describedby"
                        }
                    ]
                }
            },
            "hasPopup": {
                "class": "8",
                "param": {
                    "name": "hasPopup",
                    "attributes": [
                        {
                            "name": "aria-haspopup",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": [
                                        "true",
                                        "menu"
                                    ]
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "isExpanded": {
                "class": "9",
                "param": {
                    "name": "isExpanded",
                    "attributes": [
                        {
                            "name": "aria-expanded",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "isPressed": {
                "class": "10",
                "param": {
                    "name": "isPressed",
                    "attributes": [
                        {
                            "name": "aria-pressed",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "label": {
                "class": "11",
                "param": {
                    "name": "label",
                    "attributes": [
                        {
                            "name": "aria-label"
                        }
                    ]
                }
            },
            "labelledBy": {
                "class": "11",
                "param": {
                    "name": "labelledBy",
                    "attributes": [
                        {
                            "name": "aria-labelledby"
                        }
                    ]
                }
            },
            "tabbable": {
                "class": "12",
                "param": {
                    "name": "tabbable",
                    "attributes": [
                        {
                            "name": "tabindex",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "0"
                                },
                                {
                                    "parameter": false,
                                    "attribute": "-1"
                                }
                            ]
                        }
                    ]
                }
            },
            "disabled": {
                "class": "13",
                "param": {
                    "name": "disabled",
                    "attributes": [
                        {
                            "name": "disabled",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": true
                                },
                                {
                                    "parameter": false,
                                    "attribute": false
                                }
                            ]
                        },
                        {
                            "name": "aria-disabled",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": "false"
                                }
                            ],
                            "optional": true
                        }
                    ]
                }
            },
            "checked": {
                "class": "14",
                "param": {
                    "name": "checked",
                    "attributes": [
                        {
                            "name": "checked",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": true
                                },
                                {
                                    "parameter": false,
                                    "attribute": false
                                }
                            ]
                        },
                        {
                            "name": "aria-checked",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ],
                            "optional": true
                        }
                    ]
                }
            }
        },
        "<input>": {
            "title": {
                "class": "6",
                "param": {
                    "name": "title",
                    "attributes": [
                        {
                            "name": "title"
                        }
                    ]
                }
            },
            "describedBy": {
                "class": "7",
                "param": {
                    "name": "describedBy",
                    "attributes": [
                        {
                            "name": "aria-describedby"
                        }
                    ]
                }
            },
            "hasPopup": {
                "class": "8",
                "param": {
                    "name": "hasPopup",
                    "attributes": [
                        {
                            "name": "aria-haspopup",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": [
                                        "true",
                                        "menu"
                                    ]
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "isExpanded": {
                "class": "9",
                "param": {
                    "name": "isExpanded",
                    "attributes": [
                        {
                            "name": "aria-expanded",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "isPressed": {
                "class": "10",
                "param": {
                    "name": "isPressed",
                    "attributes": [
                        {
                            "name": "aria-pressed",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "label": {
                "class": "15",
                "param": {
                    "name": "label",
                    "attributes": [
                        {
                            "name": "aria-label"
                        }
                    ]
                }
            },
            "labelledBy": {
                "class": "15",
                "param": {
                    "name": "labelledBy",
                    "attributes": [
                        {
                            "name": "aria-labelledby"
                        }
                    ]
                }
            },
            "tabbable": {
                "class": "16",
                "param": {
                    "name": "tabbable",
                    "attributes": [
                        {
                            "name": "tabindex",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "0"
                                },
                                {
                                    "parameter": false,
                                    "attribute": "-1"
                                }
                            ]
                        }
                    ]
                }
            },
            "disabled": {
                "class": "17",
                "param": {
                    "name": "disabled",
                    "attributes": [
                        {
                            "name": "disabled",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": true
                                },
                                {
                                    "parameter": false,
                                    "attribute": false
                                }
                            ]
                        },
                        {
                            "name": "aria-disabled",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": "false"
                                }
                            ],
                            "optional": true
                        }
                    ]
                }
            },
            "checked": {
                "class": "18",
                "param": {
                    "name": "checked",
                    "attributes": [
                        {
                            "name": "checked",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": true
                                },
                                {
                                    "parameter": false,
                                    "attribute": false
                                }
                            ]
                        },
                        {
                            "name": "aria-checked",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ],
                            "optional": true
                        }
                    ]
                }
            }
        },
        "<div>, <span>": {
            "title": {
                "class": "6",
                "param": {
                    "name": "title",
                    "attributes": [
                        {
                            "name": "title"
                        }
                    ]
                }
            },
            "describedBy": {
                "class": "7",
                "param": {
                    "name": "describedBy",
                    "attributes": [
                        {
                            "name": "aria-describedby"
                        }
                    ]
                }
            },
            "hasPopup": {
                "class": "8",
                "param": {
                    "name": "hasPopup",
                    "attributes": [
                        {
                            "name": "aria-haspopup",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": [
                                        "true",
                                        "menu"
                                    ]
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "isExpanded": {
                "class": "9",
                "param": {
                    "name": "isExpanded",
                    "attributes": [
                        {
                            "name": "aria-expanded",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "isPressed": {
                "class": "10",
                "param": {
                    "name": "isPressed",
                    "attributes": [
                        {
                            "name": "aria-pressed",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "label": {
                "class": "19",
                "param": {
                    "name": "label",
                    "attributes": [
                        {
                            "name": "aria-label"
                        }
                    ]
                }
            },
            "labelledBy": {
                "class": "19",
                "param": {
                    "name": "labelledBy",
                    "attributes": [
                        {
                            "name": "aria-labelledby"
                        }
                    ]
                }
            },
            "tabbable": {
                "class": "20",
                "param": {
                    "name": "tabbable",
                    "attributes": [
                        {
                            "name": "tabindex",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "0"
                                },
                                {
                                    "parameter": false,
                                    "attribute": "-1"
                                }
                            ]
                        }
                    ]
                }
            },
            "disabled": {
                "class": "21",
                "param": {
                    "name": "disabled",
                    "attributes": [
                        {
                            "name": "aria-disabled",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "disabled",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": true
                                },
                                {
                                    "parameter": false,
                                    "attribute": false
                                }
                            ],
                            "optional": true
                        }
                    ]
                }
            },
            "checked": {
                "class": "22",
                "param": {
                    "name": "checked",
                    "attributes": [
                        {
                            "name": "aria-checked",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "checked",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": true
                                },
                                {
                                    "parameter": false,
                                    "attribute": false
                                }
                            ],
                            "optional": true
                        }
                    ]
                }
            }
        }
    }, Checkbox._tagsByTag);
    private static _attrToParamByTag = Schema.AttributeSchema._assignTagNames({
        "<button>": {
            "title": "title",
            "aria-describedby": "describedBy",
            "aria-haspopup": "hasPopup",
            "aria-expanded": "isExpanded",
            "aria-pressed": "isPressed",
            "aria-label": "label",
            "aria-labelledby": "labelledBy",
            "tabindex": "tabbable",
            "disabled": "disabled",
            "aria-disabled": "disabled",
            "checked": "checked",
            "aria-checked": "checked"
        },
        "<input>": {
            "title": "title",
            "aria-describedby": "describedBy",
            "aria-haspopup": "hasPopup",
            "aria-expanded": "isExpanded",
            "aria-pressed": "isPressed",
            "aria-label": "label",
            "aria-labelledby": "labelledBy",
            "tabindex": "tabbable",
            "disabled": "disabled",
            "aria-disabled": "disabled",
            "checked": "checked",
            "aria-checked": "checked"
        },
        "<div>, <span>": {
            "title": "title",
            "aria-describedby": "describedBy",
            "aria-haspopup": "hasPopup",
            "aria-expanded": "isExpanded",
            "aria-pressed": "isPressed",
            "aria-label": "label",
            "aria-labelledby": "labelledBy",
            "tabindex": "tabbable",
            "aria-disabled": "disabled",
            "disabled": "disabled",
            "aria-checked": "checked",
            "checked": "checked"
        }
    }, Checkbox._tagsByTag);
    private static _paramToAttrByTag = Schema.AttributeSchema._assignTagNames({
        "<button>": {
            "title": "title",
            "describedBy": "aria-describedby",
            "hasPopup": "aria-haspopup",
            "isExpanded": "aria-expanded",
            "isPressed": "aria-pressed",
            "label": "aria-label",
            "labelledBy": "aria-labelledby",
            "tabbable": "tabindex",
            "disabled": "aria-disabled",
            "checked": "aria-checked"
        },
        "<input>": {
            "title": "title",
            "describedBy": "aria-describedby",
            "hasPopup": "aria-haspopup",
            "isExpanded": "aria-expanded",
            "isPressed": "aria-pressed",
            "label": "aria-label",
            "labelledBy": "aria-labelledby",
            "tabbable": "tabindex",
            "disabled": "aria-disabled",
            "checked": "aria-checked"
        },
        "<div>, <span>": {
            "title": "title",
            "describedBy": "aria-describedby",
            "hasPopup": "aria-haspopup",
            "isExpanded": "aria-expanded",
            "isPressed": "aria-pressed",
            "label": "aria-label",
            "labelledBy": "aria-labelledby",
            "tabbable": "tabindex",
            "disabled": "disabled",
            "checked": "checked"
        }
    }, Checkbox._tagsByTag);
    private static _nonParamAttrsByTag = Schema.AttributeSchema._assignTagNames({
        "<button>": {
            "role": {
                "class": "1",
                "attr": {
                    "name": "role",
                    "default": "checkbox",
                    "value": {
                        "checkbox": true
                    }
                }
            }
        },
        "<input>": {
            "type": {
                "class": "2",
                "attr": {
                    "name": "type",
                    "default": "checkbox",
                    "value": {
                        "checkbox": true
                    }
                }
            },
            "role": {
                "class": "3",
                "attr": {
                    "name": "role",
                    "default": "checkbox",
                    "value": {
                        "checkbox": true
                    },
                    "optional": true
                }
            }
        },
        "<div>, <span>": {
            "role": {
                "class": "4",
                "attr": {
                    "name": "role",
                    "default": "checkbox",
                    "value": {
                        "checkbox": true
                    }
                }
            },
            "tabindex": {
                "class": "5",
                "attr": {
                    "name": "tabindex",
                    "default": "0",
                    "value": {
                        "0": true,
                        "-1": true
                    }
                }
            }
        }
    }, Checkbox._tagsByTag);
    private static _mandatoryParams = {};

    protected _className = Checkbox.className;
    protected _allParamsByTag = Checkbox._allParamsByTag;
    protected _attrToParamByTag = Checkbox._attrToParamByTag;
    protected _mandatoryParams = Checkbox._mandatoryParams;
    protected _nonParamAttrsByTag = Checkbox._nonParamAttrsByTag;

    constructor(tagName: string, params: Checkbox_Params) {
        super(tagName, params);

        if (process.env.NODE_ENV !== 'production') {
            const classConstraints: Schema.Constraint[] = [
                {
                    "xpath": "not(boolean((.//*[@role and @role != 'none' and @role != 'presentation'] | .//a | .//area | .//button | .//input | .//object | .//select | .//textarea)[not(ancestor-or-self::*/@aria-hidden = 'true')]))",
                    "description": "Element cannot contain other accessible elements"
                }
            ];

            const tagConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({}, Checkbox._tagsByTag)[tagName];

            const paramConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({
                "<button>": {
                    "title": [
                        {
                            "xpath": "normalize-space(@title) != ''",
                            "description": "title attribute value cannot be empty"
                        },
                        {
                            "js": "equalsToAccessibilityLabelIfAny",
                            "description": "In order to not confuse the users, the title attribute value should be equal to the accessibility label value"
                        }
                    ],
                    "describedBy": [
                        {
                            "js": "checkIdentifiers",
                            "description": "Value must be space-separated list of existing element identifiers"
                        }
                    ],
                    "label": [
                        {
                            "xpath": "normalize-space(@aria-label) != ''",
                            "description": "aria-label attribute value cannot be empty"
                        }
                    ],
                    "labelledBy": [
                        {
                            "js": "checkIdentifiers",
                            "description": "Value must be space-separated list of existing element identifiers"
                        }
                    ]
                },
                "<input>": {
                    "title": [
                        {
                            "xpath": "normalize-space(@title) != ''",
                            "description": "title attribute value cannot be empty"
                        },
                        {
                            "js": "equalsToAccessibilityLabelIfAny",
                            "description": "In order to not confuse the users, the title attribute value should be equal to the accessibility label value"
                        }
                    ],
                    "describedBy": [
                        {
                            "js": "checkIdentifiers",
                            "description": "Value must be space-separated list of existing element identifiers"
                        }
                    ],
                    "label": [
                        {
                            "xpath": "normalize-space(@aria-label) != ''",
                            "description": "aria-label attribute value cannot be empty"
                        }
                    ],
                    "labelledBy": [
                        {
                            "js": "checkIdentifiers",
                            "description": "Value must be space-separated list of existing element identifiers"
                        }
                    ]
                },
                "<div>, <span>": {
                    "title": [
                        {
                            "xpath": "normalize-space(@title) != ''",
                            "description": "title attribute value cannot be empty"
                        },
                        {
                            "js": "equalsToAccessibilityLabelIfAny",
                            "description": "In order to not confuse the users, the title attribute value should be equal to the accessibility label value"
                        }
                    ],
                    "describedBy": [
                        {
                            "js": "checkIdentifiers",
                            "description": "Value must be space-separated list of existing element identifiers"
                        }
                    ],
                    "label": [
                        {
                            "xpath": "normalize-space(@aria-label) != ''",
                            "description": "aria-label attribute value cannot be empty"
                        }
                    ],
                    "labelledBy": [
                        {
                            "js": "checkIdentifiers",
                            "description": "Value must be space-separated list of existing element identifiers"
                        }
                    ]
                }
            }, Checkbox._tagsByTag)[tagName];

            const paramOptionalConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({
                "<button>": {
                    "label, labelledBy": [
                        {
                            "xpath": "boolean(@title and @title != '') or boolean(.//text()[normalize-space(.) != ''])",
                            "description": "Element must contain text nodes or title attribute"
                        }
                    ]
                },
                "<input>": {
                    "label, labelledBy": [
                        {
                            "xpath": "normalize-space(@value) != ''",
                            "description": "Element must contain value attribute"
                        }
                    ]
                },
                "<div>, <span>": {
                    "label, labelledBy": [
                        {
                            "xpath": "boolean(@title and @title != '') or boolean(.//text()[normalize-space(.) != ''])",
                            "description": "Element must contain text nodes or title attribute"
                        }
                    ]
                }
            }, Checkbox._tagsByTag)[tagName];

            this.getConstraints = () => {
                const constraints: Schema.ParamConstraint[] = classConstraints.slice(0);

                if (tagConstraints) {
                    Array.prototype.push.apply(constraints, tagConstraints);
                }

                for (let paramName of Object.keys(paramConstraints)) {
                    if (paramName in this._params) {
                        Array.prototype.push.apply(constraints, paramConstraints[paramName].map(c => {
                            return { ...c, name: paramName, value: this._params[paramName as keyof Checkbox_Params] };
                        }));
                    }
                }

                for (let paramName of Object.keys(paramOptionalConstraints)) {
                    const paramNames = paramName.split(', ');
                    const paramNamesText = paramNames.map(p => `'${ p }'`).join(' or ');

                    if (!(paramNames.some(n => n in this._params))) {
                        Array.prototype.push.apply(
                            constraints,
                            paramOptionalConstraints[paramName].map(c => { return { ...c, param: paramNamesText }; })
                        );
                    }
                }

                return constraints;
            };
        }
    }

    static fromAttributes(tagName: string, attributes: HTMLElementAttributes): Checkbox {
        const pd = Schema.AttributeSchema._getParamsFromAttributes<Checkbox_Params>(
            tagName,
            attributes,
            Checkbox.className,
            Checkbox._allParamsByTag,
            Checkbox._attrToParamByTag,
            Checkbox._paramToAttrByTag,
            Checkbox._mandatoryParams,
            Checkbox._nonParamAttrsByTag
        );

        const instance = new Checkbox(tagName, pd.params);

        instance._setDefaults(pd.defaults);

        return instance;
    }
}


export type RadioGroupItem_Params = {
    label?: string;
    labelledBy?: never;
    title?: string;
    describedBy?: string;
    hasPopup?: true | false;
    isExpanded?: true | false;
    isPressed?: true | false;
    tabbable?: true | false;
    disabled?: true | false;
    checked?: true | false;
} | {
    label?: never;
    labelledBy?: string;
    title?: string;
    describedBy?: string;
    hasPopup?: true | false;
    isExpanded?: true | false;
    isPressed?: true | false;
    tabbable?: true | false;
    disabled?: true | false;
    checked?: true | false;
}

export class RadioGroupItem extends Schema.AttributeSchema<RadioGroupItem_Params> {
    static className = "RadioGroupItem";
    private static _tagsByTag: Schema.TagsByTag = {"button":"<button>","input":"<input>","div":"<div>, <span>","span":"<div>, <span>"};
    private static _allParamsByTag = Schema.AttributeSchema._assignTagNames({
        "<button>": {
            "title": {
                "class": "6",
                "param": {
                    "name": "title",
                    "attributes": [
                        {
                            "name": "title"
                        }
                    ]
                }
            },
            "describedBy": {
                "class": "7",
                "param": {
                    "name": "describedBy",
                    "attributes": [
                        {
                            "name": "aria-describedby"
                        }
                    ]
                }
            },
            "hasPopup": {
                "class": "8",
                "param": {
                    "name": "hasPopup",
                    "attributes": [
                        {
                            "name": "aria-haspopup",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": [
                                        "true",
                                        "menu"
                                    ]
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "isExpanded": {
                "class": "9",
                "param": {
                    "name": "isExpanded",
                    "attributes": [
                        {
                            "name": "aria-expanded",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "isPressed": {
                "class": "10",
                "param": {
                    "name": "isPressed",
                    "attributes": [
                        {
                            "name": "aria-pressed",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "label": {
                "class": "11",
                "param": {
                    "name": "label",
                    "attributes": [
                        {
                            "name": "aria-label"
                        }
                    ]
                }
            },
            "labelledBy": {
                "class": "11",
                "param": {
                    "name": "labelledBy",
                    "attributes": [
                        {
                            "name": "aria-labelledby"
                        }
                    ]
                }
            },
            "tabbable": {
                "class": "12",
                "param": {
                    "name": "tabbable",
                    "attributes": [
                        {
                            "name": "tabindex",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "0"
                                },
                                {
                                    "parameter": false,
                                    "attribute": "-1"
                                }
                            ]
                        }
                    ]
                }
            },
            "disabled": {
                "class": "13",
                "param": {
                    "name": "disabled",
                    "attributes": [
                        {
                            "name": "disabled",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": true
                                },
                                {
                                    "parameter": false,
                                    "attribute": false
                                }
                            ]
                        },
                        {
                            "name": "aria-disabled",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": "false"
                                }
                            ],
                            "optional": true
                        }
                    ]
                }
            },
            "checked": {
                "class": "14",
                "param": {
                    "name": "checked",
                    "attributes": [
                        {
                            "name": "checked",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": true
                                },
                                {
                                    "parameter": false,
                                    "attribute": false
                                }
                            ]
                        },
                        {
                            "name": "aria-checked",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ],
                            "optional": true
                        }
                    ]
                }
            }
        },
        "<input>": {
            "title": {
                "class": "6",
                "param": {
                    "name": "title",
                    "attributes": [
                        {
                            "name": "title"
                        }
                    ]
                }
            },
            "describedBy": {
                "class": "7",
                "param": {
                    "name": "describedBy",
                    "attributes": [
                        {
                            "name": "aria-describedby"
                        }
                    ]
                }
            },
            "hasPopup": {
                "class": "8",
                "param": {
                    "name": "hasPopup",
                    "attributes": [
                        {
                            "name": "aria-haspopup",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": [
                                        "true",
                                        "menu"
                                    ]
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "isExpanded": {
                "class": "9",
                "param": {
                    "name": "isExpanded",
                    "attributes": [
                        {
                            "name": "aria-expanded",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "isPressed": {
                "class": "10",
                "param": {
                    "name": "isPressed",
                    "attributes": [
                        {
                            "name": "aria-pressed",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "label": {
                "class": "15",
                "param": {
                    "name": "label",
                    "attributes": [
                        {
                            "name": "aria-label"
                        }
                    ]
                }
            },
            "labelledBy": {
                "class": "15",
                "param": {
                    "name": "labelledBy",
                    "attributes": [
                        {
                            "name": "aria-labelledby"
                        }
                    ]
                }
            },
            "tabbable": {
                "class": "16",
                "param": {
                    "name": "tabbable",
                    "attributes": [
                        {
                            "name": "tabindex",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "0"
                                },
                                {
                                    "parameter": false,
                                    "attribute": "-1"
                                }
                            ]
                        }
                    ]
                }
            },
            "disabled": {
                "class": "17",
                "param": {
                    "name": "disabled",
                    "attributes": [
                        {
                            "name": "disabled",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": true
                                },
                                {
                                    "parameter": false,
                                    "attribute": false
                                }
                            ]
                        },
                        {
                            "name": "aria-disabled",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": "false"
                                }
                            ],
                            "optional": true
                        }
                    ]
                }
            },
            "checked": {
                "class": "18",
                "param": {
                    "name": "checked",
                    "attributes": [
                        {
                            "name": "checked",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": true
                                },
                                {
                                    "parameter": false,
                                    "attribute": false
                                }
                            ]
                        },
                        {
                            "name": "aria-checked",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ],
                            "optional": true
                        }
                    ]
                }
            }
        },
        "<div>, <span>": {
            "title": {
                "class": "6",
                "param": {
                    "name": "title",
                    "attributes": [
                        {
                            "name": "title"
                        }
                    ]
                }
            },
            "describedBy": {
                "class": "7",
                "param": {
                    "name": "describedBy",
                    "attributes": [
                        {
                            "name": "aria-describedby"
                        }
                    ]
                }
            },
            "hasPopup": {
                "class": "8",
                "param": {
                    "name": "hasPopup",
                    "attributes": [
                        {
                            "name": "aria-haspopup",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": [
                                        "true",
                                        "menu"
                                    ]
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "isExpanded": {
                "class": "9",
                "param": {
                    "name": "isExpanded",
                    "attributes": [
                        {
                            "name": "aria-expanded",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "isPressed": {
                "class": "10",
                "param": {
                    "name": "isPressed",
                    "attributes": [
                        {
                            "name": "aria-pressed",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            "label": {
                "class": "19",
                "param": {
                    "name": "label",
                    "attributes": [
                        {
                            "name": "aria-label"
                        }
                    ]
                }
            },
            "labelledBy": {
                "class": "19",
                "param": {
                    "name": "labelledBy",
                    "attributes": [
                        {
                            "name": "aria-labelledby"
                        }
                    ]
                }
            },
            "tabbable": {
                "class": "20",
                "param": {
                    "name": "tabbable",
                    "attributes": [
                        {
                            "name": "tabindex",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "0"
                                },
                                {
                                    "parameter": false,
                                    "attribute": "-1"
                                }
                            ]
                        }
                    ]
                }
            },
            "disabled": {
                "class": "21",
                "param": {
                    "name": "disabled",
                    "attributes": [
                        {
                            "name": "aria-disabled",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "disabled",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": true
                                },
                                {
                                    "parameter": false,
                                    "attribute": false
                                }
                            ],
                            "optional": true
                        }
                    ]
                }
            },
            "checked": {
                "class": "22",
                "param": {
                    "name": "checked",
                    "attributes": [
                        {
                            "name": "aria-checked",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": "true"
                                },
                                {
                                    "parameter": false,
                                    "attribute": [
                                        false,
                                        "false"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "checked",
                            "value": [
                                {
                                    "parameter": true,
                                    "attribute": true
                                },
                                {
                                    "parameter": false,
                                    "attribute": false
                                }
                            ],
                            "optional": true
                        }
                    ]
                }
            }
        }
    }, RadioGroupItem._tagsByTag);
    private static _attrToParamByTag = Schema.AttributeSchema._assignTagNames({
        "<button>": {
            "title": "title",
            "aria-describedby": "describedBy",
            "aria-haspopup": "hasPopup",
            "aria-expanded": "isExpanded",
            "aria-pressed": "isPressed",
            "aria-label": "label",
            "aria-labelledby": "labelledBy",
            "tabindex": "tabbable",
            "disabled": "disabled",
            "aria-disabled": "disabled",
            "checked": "checked",
            "aria-checked": "checked"
        },
        "<input>": {
            "title": "title",
            "aria-describedby": "describedBy",
            "aria-haspopup": "hasPopup",
            "aria-expanded": "isExpanded",
            "aria-pressed": "isPressed",
            "aria-label": "label",
            "aria-labelledby": "labelledBy",
            "tabindex": "tabbable",
            "disabled": "disabled",
            "aria-disabled": "disabled",
            "checked": "checked",
            "aria-checked": "checked"
        },
        "<div>, <span>": {
            "title": "title",
            "aria-describedby": "describedBy",
            "aria-haspopup": "hasPopup",
            "aria-expanded": "isExpanded",
            "aria-pressed": "isPressed",
            "aria-label": "label",
            "aria-labelledby": "labelledBy",
            "tabindex": "tabbable",
            "aria-disabled": "disabled",
            "disabled": "disabled",
            "aria-checked": "checked",
            "checked": "checked"
        }
    }, RadioGroupItem._tagsByTag);
    private static _paramToAttrByTag = Schema.AttributeSchema._assignTagNames({
        "<button>": {
            "title": "title",
            "describedBy": "aria-describedby",
            "hasPopup": "aria-haspopup",
            "isExpanded": "aria-expanded",
            "isPressed": "aria-pressed",
            "label": "aria-label",
            "labelledBy": "aria-labelledby",
            "tabbable": "tabindex",
            "disabled": "aria-disabled",
            "checked": "aria-checked"
        },
        "<input>": {
            "title": "title",
            "describedBy": "aria-describedby",
            "hasPopup": "aria-haspopup",
            "isExpanded": "aria-expanded",
            "isPressed": "aria-pressed",
            "label": "aria-label",
            "labelledBy": "aria-labelledby",
            "tabbable": "tabindex",
            "disabled": "aria-disabled",
            "checked": "aria-checked"
        },
        "<div>, <span>": {
            "title": "title",
            "describedBy": "aria-describedby",
            "hasPopup": "aria-haspopup",
            "isExpanded": "aria-expanded",
            "isPressed": "aria-pressed",
            "label": "aria-label",
            "labelledBy": "aria-labelledby",
            "tabbable": "tabindex",
            "disabled": "disabled",
            "checked": "checked"
        }
    }, RadioGroupItem._tagsByTag);
    private static _nonParamAttrsByTag = Schema.AttributeSchema._assignTagNames({
        "<button>": {
            "role": {
                "class": "1",
                "attr": {
                    "name": "role",
                    "default": "radio",
                    "value": {
                        "radio": true
                    }
                }
            }
        },
        "<input>": {
            "type": {
                "class": "2",
                "attr": {
                    "name": "type",
                    "default": "radio",
                    "value": {
                        "radio": true
                    }
                }
            },
            "role": {
                "class": "3",
                "attr": {
                    "name": "role",
                    "default": "radio",
                    "value": {
                        "radio": true
                    },
                    "optional": true
                }
            }
        },
        "<div>, <span>": {
            "role": {
                "class": "4",
                "attr": {
                    "name": "role",
                    "default": "radio",
                    "value": {
                        "radio": true
                    }
                }
            },
            "tabindex": {
                "class": "5",
                "attr": {
                    "name": "tabindex",
                    "default": "0",
                    "value": {
                        "0": true,
                        "-1": true
                    }
                }
            }
        }
    }, RadioGroupItem._tagsByTag);
    private static _mandatoryParams = {};

    protected _className = RadioGroupItem.className;
    protected _allParamsByTag = RadioGroupItem._allParamsByTag;
    protected _attrToParamByTag = RadioGroupItem._attrToParamByTag;
    protected _mandatoryParams = RadioGroupItem._mandatoryParams;
    protected _nonParamAttrsByTag = RadioGroupItem._nonParamAttrsByTag;

    constructor(tagName: string, params: RadioGroupItem_Params) {
        super(tagName, params);

        if (process.env.NODE_ENV !== 'production') {
            const classConstraints: Schema.Constraint[] = [
                {
                    "xpath": "not(boolean((.//*[@role and @role != 'none' and @role != 'presentation'] | .//a | .//area | .//button | .//input | .//object | .//select | .//textarea)[not(ancestor-or-self::*/@aria-hidden = 'true')]))",
                    "description": "Element cannot contain other accessible elements"
                }
            ];

            const tagConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({}, RadioGroupItem._tagsByTag)[tagName];

            const paramConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({
                "<button>": {
                    "title": [
                        {
                            "xpath": "normalize-space(@title) != ''",
                            "description": "title attribute value cannot be empty"
                        },
                        {
                            "js": "equalsToAccessibilityLabelIfAny",
                            "description": "In order to not confuse the users, the title attribute value should be equal to the accessibility label value"
                        }
                    ],
                    "describedBy": [
                        {
                            "js": "checkIdentifiers",
                            "description": "Value must be space-separated list of existing element identifiers"
                        }
                    ],
                    "label": [
                        {
                            "xpath": "normalize-space(@aria-label) != ''",
                            "description": "aria-label attribute value cannot be empty"
                        }
                    ],
                    "labelledBy": [
                        {
                            "js": "checkIdentifiers",
                            "description": "Value must be space-separated list of existing element identifiers"
                        }
                    ]
                },
                "<input>": {
                    "title": [
                        {
                            "xpath": "normalize-space(@title) != ''",
                            "description": "title attribute value cannot be empty"
                        },
                        {
                            "js": "equalsToAccessibilityLabelIfAny",
                            "description": "In order to not confuse the users, the title attribute value should be equal to the accessibility label value"
                        }
                    ],
                    "describedBy": [
                        {
                            "js": "checkIdentifiers",
                            "description": "Value must be space-separated list of existing element identifiers"
                        }
                    ],
                    "label": [
                        {
                            "xpath": "normalize-space(@aria-label) != ''",
                            "description": "aria-label attribute value cannot be empty"
                        }
                    ],
                    "labelledBy": [
                        {
                            "js": "checkIdentifiers",
                            "description": "Value must be space-separated list of existing element identifiers"
                        }
                    ]
                },
                "<div>, <span>": {
                    "title": [
                        {
                            "xpath": "normalize-space(@title) != ''",
                            "description": "title attribute value cannot be empty"
                        },
                        {
                            "js": "equalsToAccessibilityLabelIfAny",
                            "description": "In order to not confuse the users, the title attribute value should be equal to the accessibility label value"
                        }
                    ],
                    "describedBy": [
                        {
                            "js": "checkIdentifiers",
                            "description": "Value must be space-separated list of existing element identifiers"
                        }
                    ],
                    "label": [
                        {
                            "xpath": "normalize-space(@aria-label) != ''",
                            "description": "aria-label attribute value cannot be empty"
                        }
                    ],
                    "labelledBy": [
                        {
                            "js": "checkIdentifiers",
                            "description": "Value must be space-separated list of existing element identifiers"
                        }
                    ]
                }
            }, RadioGroupItem._tagsByTag)[tagName];

            const paramOptionalConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({
                "<button>": {
                    "label, labelledBy": [
                        {
                            "xpath": "boolean(@title and @title != '') or boolean(.//text()[normalize-space(.) != ''])",
                            "description": "Element must contain text nodes or title attribute"
                        }
                    ]
                },
                "<input>": {
                    "label, labelledBy": [
                        {
                            "xpath": "normalize-space(@value) != ''",
                            "description": "Element must contain value attribute"
                        }
                    ]
                },
                "<div>, <span>": {
                    "label, labelledBy": [
                        {
                            "xpath": "boolean(@title and @title != '') or boolean(.//text()[normalize-space(.) != ''])",
                            "description": "Element must contain text nodes or title attribute"
                        }
                    ]
                }
            }, RadioGroupItem._tagsByTag)[tagName];

            this.getConstraints = () => {
                const constraints: Schema.ParamConstraint[] = classConstraints.slice(0);

                if (tagConstraints) {
                    Array.prototype.push.apply(constraints, tagConstraints);
                }

                for (let paramName of Object.keys(paramConstraints)) {
                    if (paramName in this._params) {
                        Array.prototype.push.apply(constraints, paramConstraints[paramName].map(c => {
                            return { ...c, name: paramName, value: this._params[paramName as keyof RadioGroupItem_Params] };
                        }));
                    }
                }

                for (let paramName of Object.keys(paramOptionalConstraints)) {
                    const paramNames = paramName.split(', ');
                    const paramNamesText = paramNames.map(p => `'${ p }'`).join(' or ');

                    if (!(paramNames.some(n => n in this._params))) {
                        Array.prototype.push.apply(
                            constraints,
                            paramOptionalConstraints[paramName].map(c => { return { ...c, param: paramNamesText }; })
                        );
                    }
                }

                return constraints;
            };
        }
    }

    static fromAttributes(tagName: string, attributes: HTMLElementAttributes): RadioGroupItem {
        const pd = Schema.AttributeSchema._getParamsFromAttributes<RadioGroupItem_Params>(
            tagName,
            attributes,
            RadioGroupItem.className,
            RadioGroupItem._allParamsByTag,
            RadioGroupItem._attrToParamByTag,
            RadioGroupItem._paramToAttrByTag,
            RadioGroupItem._mandatoryParams,
            RadioGroupItem._nonParamAttrsByTag
        );

        const instance = new RadioGroupItem(tagName, pd.params);

        instance._setDefaults(pd.defaults);

        return instance;
    }
}


export type FormField_Params = {
    
}

export class FormField extends Schema.AttributeSchema<FormField_Params> {
    static className = "FormField";
    private static _tagsByTag: Schema.TagsByTag = {"div":"<div>, <span>","span":"<div>, <span>"};
    private static _allParamsByTag = Schema.AttributeSchema._assignTagNames({
        "<div>, <span>": {}
    }, FormField._tagsByTag);
    private static _attrToParamByTag = Schema.AttributeSchema._assignTagNames({
        "<div>, <span>": {}
    }, FormField._tagsByTag);
    private static _paramToAttrByTag = Schema.AttributeSchema._assignTagNames({
        "<div>, <span>": {}
    }, FormField._tagsByTag);
    private static _nonParamAttrsByTag = Schema.AttributeSchema._assignTagNames({
        "<div>, <span>": {}
    }, FormField._tagsByTag);
    private static _mandatoryParams = {};

    protected _className = FormField.className;
    protected _allParamsByTag = FormField._allParamsByTag;
    protected _attrToParamByTag = FormField._attrToParamByTag;
    protected _mandatoryParams = FormField._mandatoryParams;
    protected _nonParamAttrsByTag = FormField._nonParamAttrsByTag;

    constructor(tagName: string, params: FormField_Params) {
        super(tagName, params);

        if (process.env.NODE_ENV !== 'production') {
            const classConstraints: Schema.Constraint[] = [
                {
                    "xpath": ".//label[@id and boolean(normalize-space(.//text()) != '')] | .//button | .//*[@role='checkbox']",
                    "description": "Label should always have id and some text content"
                },
                {
                    "xpath": ".//input[@aria-labelledby|@id] | .//button | .//*[@role='checkbox']",
                    "description": "Should have input containing either id or aria-labelledby"
                },
                {
                    "xpath": "boolean(.//*[@aria-invalid] and .//*[@role='alert' and @id] and .//*[@aria-labelledby]) or not(.//*[@aria-invalid])",
                    "description": "Message should have identifier, role='alert' and combined with a `aria-invalid` and `aria-labelledby` input"
                }
            ];

            const tagConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({}, FormField._tagsByTag)[tagName];

            const paramConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({
                "<div>, <span>": {}
            }, FormField._tagsByTag)[tagName];

            const paramOptionalConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({
                "<div>, <span>": {}
            }, FormField._tagsByTag)[tagName];

            this.getConstraints = () => {
                const constraints: Schema.ParamConstraint[] = classConstraints.slice(0);

                if (tagConstraints) {
                    Array.prototype.push.apply(constraints, tagConstraints);
                }

                for (let paramName of Object.keys(paramConstraints)) {
                    if (paramName in this._params) {
                        Array.prototype.push.apply(constraints, paramConstraints[paramName].map(c => {
                            return { ...c, name: paramName, value: this._params[paramName as keyof FormField_Params] };
                        }));
                    }
                }

                for (let paramName of Object.keys(paramOptionalConstraints)) {
                    const paramNames = paramName.split(', ');
                    const paramNamesText = paramNames.map(p => `'${ p }'`).join(' or ');

                    if (!(paramNames.some(n => n in this._params))) {
                        Array.prototype.push.apply(
                            constraints,
                            paramOptionalConstraints[paramName].map(c => { return { ...c, param: paramNamesText }; })
                        );
                    }
                }

                return constraints;
            };
        }
    }

    static fromAttributes(tagName: string, attributes: HTMLElementAttributes): FormField {
        const pd = Schema.AttributeSchema._getParamsFromAttributes<FormField_Params>(
            tagName,
            attributes,
            FormField.className,
            FormField._allParamsByTag,
            FormField._attrToParamByTag,
            FormField._paramToAttrByTag,
            FormField._mandatoryParams,
            FormField._nonParamAttrsByTag
        );

        const instance = new FormField(tagName, pd.params);

        instance._setDefaults(pd.defaults);

        return instance;
    }
}


export type FormInput_Params = {
    
}

export class FormInput extends Schema.AttributeSchema<FormInput_Params> {
    static className = "FormInput";
    private static _tagsByTag: Schema.TagsByTag = {"div":"<div>, <span>","span":"<div>, <span>"};
    private static _allParamsByTag = Schema.AttributeSchema._assignTagNames({
        "<div>, <span>": {}
    }, FormInput._tagsByTag);
    private static _attrToParamByTag = Schema.AttributeSchema._assignTagNames({
        "<div>, <span>": {}
    }, FormInput._tagsByTag);
    private static _paramToAttrByTag = Schema.AttributeSchema._assignTagNames({
        "<div>, <span>": {}
    }, FormInput._tagsByTag);
    private static _nonParamAttrsByTag = Schema.AttributeSchema._assignTagNames({
        "<div>, <span>": {}
    }, FormInput._tagsByTag);
    private static _mandatoryParams = {};

    protected _className = FormInput.className;
    protected _allParamsByTag = FormInput._allParamsByTag;
    protected _attrToParamByTag = FormInput._attrToParamByTag;
    protected _mandatoryParams = FormInput._mandatoryParams;
    protected _nonParamAttrsByTag = FormInput._nonParamAttrsByTag;

    constructor(tagName: string, params: FormInput_Params) {
        super(tagName, params);

        if (process.env.NODE_ENV !== 'production') {
            const classConstraints: Schema.Constraint[] = [
                {
                    "xpath": ".//label[@id and boolean(normalize-space(.//text()) != '')] | .//button | .//*[@role='checkbox']",
                    "description": "Label should always have id and some text content"
                },
                {
                    "xpath": ".//input[@aria-labelledby|@id] | .//button | .//*[@role='checkbox']",
                    "description": "Should have input containing either id or aria-labelledby"
                },
                {
                    "xpath": "boolean(.//*[@aria-invalid] and .//*[@role='alert' and @id] and .//*[@aria-labelledby]) or not(.//*[@aria-invalid])",
                    "description": "Message should have identifier, role='alert' and combined with a `aria-invalid` and `aria-labelledby` input"
                }
            ];

            const tagConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({}, FormInput._tagsByTag)[tagName];

            const paramConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({
                "<div>, <span>": {}
            }, FormInput._tagsByTag)[tagName];

            const paramOptionalConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({
                "<div>, <span>": {}
            }, FormInput._tagsByTag)[tagName];

            this.getConstraints = () => {
                const constraints: Schema.ParamConstraint[] = classConstraints.slice(0);

                if (tagConstraints) {
                    Array.prototype.push.apply(constraints, tagConstraints);
                }

                for (let paramName of Object.keys(paramConstraints)) {
                    if (paramName in this._params) {
                        Array.prototype.push.apply(constraints, paramConstraints[paramName].map(c => {
                            return { ...c, name: paramName, value: this._params[paramName as keyof FormInput_Params] };
                        }));
                    }
                }

                for (let paramName of Object.keys(paramOptionalConstraints)) {
                    const paramNames = paramName.split(', ');
                    const paramNamesText = paramNames.map(p => `'${ p }'`).join(' or ');

                    if (!(paramNames.some(n => n in this._params))) {
                        Array.prototype.push.apply(
                            constraints,
                            paramOptionalConstraints[paramName].map(c => { return { ...c, param: paramNamesText }; })
                        );
                    }
                }

                return constraints;
            };
        }
    }

    static fromAttributes(tagName: string, attributes: HTMLElementAttributes): FormInput {
        const pd = Schema.AttributeSchema._getParamsFromAttributes<FormInput_Params>(
            tagName,
            attributes,
            FormInput.className,
            FormInput._allParamsByTag,
            FormInput._attrToParamByTag,
            FormInput._paramToAttrByTag,
            FormInput._mandatoryParams,
            FormInput._nonParamAttrsByTag
        );

        const instance = new FormInput(tagName, pd.params);

        instance._setDefaults(pd.defaults);

        return instance;
    }
}


export type FormRadioGroup_Params = {
    
}

export class FormRadioGroup extends Schema.AttributeSchema<FormRadioGroup_Params> {
    static className = "FormRadioGroup";
    private static _tagsByTag: Schema.TagsByTag = {"div":"<div>"};
    private static _allParamsByTag = Schema.AttributeSchema._assignTagNames({
        "<div>": {}
    }, FormRadioGroup._tagsByTag);
    private static _attrToParamByTag = Schema.AttributeSchema._assignTagNames({
        "<div>": {}
    }, FormRadioGroup._tagsByTag);
    private static _paramToAttrByTag = Schema.AttributeSchema._assignTagNames({
        "<div>": {}
    }, FormRadioGroup._tagsByTag);
    private static _nonParamAttrsByTag = Schema.AttributeSchema._assignTagNames({
        "<div>": {}
    }, FormRadioGroup._tagsByTag);
    private static _mandatoryParams = {};

    protected _className = FormRadioGroup.className;
    protected _allParamsByTag = FormRadioGroup._allParamsByTag;
    protected _attrToParamByTag = FormRadioGroup._attrToParamByTag;
    protected _mandatoryParams = FormRadioGroup._mandatoryParams;
    protected _nonParamAttrsByTag = FormRadioGroup._nonParamAttrsByTag;

    constructor(tagName: string, params: FormRadioGroup_Params) {
        super(tagName, params);

        if (process.env.NODE_ENV !== 'production') {
            const classConstraints: Schema.Constraint[] = [
                {
                    "xpath": "boolean(.//*[@role='radiogroup' and @aria-labelledby|@aria-label])",
                    "description": "RadioGroup inside form should have aria-labelledby attribute"
                },
                {
                    "xpath": ".//label[@id and boolean(normalize-space(.//text()) != '')] | .//button | .//*[@role='checkbox']",
                    "description": "Label should always have id and some text content"
                },
                {
                    "xpath": "boolean(.//*[@aria-invalid] and .//*[@role='alert' and @id] and .//*[@aria-labelledby]) or not(.//*[@aria-invalid])",
                    "description": "Message should have identifier, role='alert' and combined with a `aria-invalid` and `aria-labelledby` input"
                }
            ];

            const tagConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({}, FormRadioGroup._tagsByTag)[tagName];

            const paramConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({
                "<div>": {}
            }, FormRadioGroup._tagsByTag)[tagName];

            const paramOptionalConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({
                "<div>": {}
            }, FormRadioGroup._tagsByTag)[tagName];

            this.getConstraints = () => {
                const constraints: Schema.ParamConstraint[] = classConstraints.slice(0);

                if (tagConstraints) {
                    Array.prototype.push.apply(constraints, tagConstraints);
                }

                for (let paramName of Object.keys(paramConstraints)) {
                    if (paramName in this._params) {
                        Array.prototype.push.apply(constraints, paramConstraints[paramName].map(c => {
                            return { ...c, name: paramName, value: this._params[paramName as keyof FormRadioGroup_Params] };
                        }));
                    }
                }

                for (let paramName of Object.keys(paramOptionalConstraints)) {
                    const paramNames = paramName.split(', ');
                    const paramNamesText = paramNames.map(p => `'${ p }'`).join(' or ');

                    if (!(paramNames.some(n => n in this._params))) {
                        Array.prototype.push.apply(
                            constraints,
                            paramOptionalConstraints[paramName].map(c => { return { ...c, param: paramNamesText }; })
                        );
                    }
                }

                return constraints;
            };
        }
    }

    static fromAttributes(tagName: string, attributes: HTMLElementAttributes): FormRadioGroup {
        const pd = Schema.AttributeSchema._getParamsFromAttributes<FormRadioGroup_Params>(
            tagName,
            attributes,
            FormRadioGroup.className,
            FormRadioGroup._allParamsByTag,
            FormRadioGroup._attrToParamByTag,
            FormRadioGroup._paramToAttrByTag,
            FormRadioGroup._mandatoryParams,
            FormRadioGroup._nonParamAttrsByTag
        );

        const instance = new FormRadioGroup(tagName, pd.params);

        instance._setDefaults(pd.defaults);

        return instance;
    }
}


export type FormDropdown_Params = {
    
}

export class FormDropdown extends Schema.AttributeSchema<FormDropdown_Params> {
    static className = "FormDropdown";
    private static _tagsByTag: Schema.TagsByTag = {"div":"<div>, <span>","span":"<div>, <span>"};
    private static _allParamsByTag = Schema.AttributeSchema._assignTagNames({
        "<div>, <span>": {}
    }, FormDropdown._tagsByTag);
    private static _attrToParamByTag = Schema.AttributeSchema._assignTagNames({
        "<div>, <span>": {}
    }, FormDropdown._tagsByTag);
    private static _paramToAttrByTag = Schema.AttributeSchema._assignTagNames({
        "<div>, <span>": {}
    }, FormDropdown._tagsByTag);
    private static _nonParamAttrsByTag = Schema.AttributeSchema._assignTagNames({
        "<div>, <span>": {}
    }, FormDropdown._tagsByTag);
    private static _mandatoryParams = {};

    protected _className = FormDropdown.className;
    protected _allParamsByTag = FormDropdown._allParamsByTag;
    protected _attrToParamByTag = FormDropdown._attrToParamByTag;
    protected _mandatoryParams = FormDropdown._mandatoryParams;
    protected _nonParamAttrsByTag = FormDropdown._nonParamAttrsByTag;

    constructor(tagName: string, params: FormDropdown_Params) {
        super(tagName, params);

        if (process.env.NODE_ENV !== 'production') {
            const classConstraints: Schema.Constraint[] = [
                {
                    "xpath": ".//label[@id and boolean(normalize-space(.//text()) != '')] | .//button | .//*[@role='checkbox']",
                    "description": "Label should always have id and some text content"
                },
                {
                    "xpath": ".//input[@aria-labelledby|@id] | .//button | .//*[@role='checkbox']",
                    "description": "Should have input containing either id or aria-labelledby"
                },
                {
                    "xpath": "boolean(.//*[@aria-invalid] and .//*[@role='alert' and @id] and .//*[@aria-labelledby]) or not(.//*[@aria-invalid])",
                    "description": "Message should have identifier, role='alert' and combined with a `aria-invalid` and `aria-labelledby` input"
                }
            ];

            const tagConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({}, FormDropdown._tagsByTag)[tagName];

            const paramConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({
                "<div>, <span>": {}
            }, FormDropdown._tagsByTag)[tagName];

            const paramOptionalConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({
                "<div>, <span>": {}
            }, FormDropdown._tagsByTag)[tagName];

            this.getConstraints = () => {
                const constraints: Schema.ParamConstraint[] = classConstraints.slice(0);

                if (tagConstraints) {
                    Array.prototype.push.apply(constraints, tagConstraints);
                }

                for (let paramName of Object.keys(paramConstraints)) {
                    if (paramName in this._params) {
                        Array.prototype.push.apply(constraints, paramConstraints[paramName].map(c => {
                            return { ...c, name: paramName, value: this._params[paramName as keyof FormDropdown_Params] };
                        }));
                    }
                }

                for (let paramName of Object.keys(paramOptionalConstraints)) {
                    const paramNames = paramName.split(', ');
                    const paramNamesText = paramNames.map(p => `'${ p }'`).join(' or ');

                    if (!(paramNames.some(n => n in this._params))) {
                        Array.prototype.push.apply(
                            constraints,
                            paramOptionalConstraints[paramName].map(c => { return { ...c, param: paramNamesText }; })
                        );
                    }
                }

                return constraints;
            };
        }
    }

    static fromAttributes(tagName: string, attributes: HTMLElementAttributes): FormDropdown {
        const pd = Schema.AttributeSchema._getParamsFromAttributes<FormDropdown_Params>(
            tagName,
            attributes,
            FormDropdown.className,
            FormDropdown._allParamsByTag,
            FormDropdown._attrToParamByTag,
            FormDropdown._paramToAttrByTag,
            FormDropdown._mandatoryParams,
            FormDropdown._nonParamAttrsByTag
        );

        const instance = new FormDropdown(tagName, pd.params);

        instance._setDefaults(pd.defaults);

        return instance;
    }
}


export type FormMessage_Params = {
    
}

export class FormMessage extends Schema.AttributeSchema<FormMessage_Params> {
    static className = "FormMessage";
    private static _tagsByTag: Schema.TagsByTag = {"span":"<span>, <div>","div":"<span>, <div>"};
    private static _allParamsByTag = Schema.AttributeSchema._assignTagNames({
        "<span>, <div>": {}
    }, FormMessage._tagsByTag);
    private static _attrToParamByTag = Schema.AttributeSchema._assignTagNames({
        "<span>, <div>": {}
    }, FormMessage._tagsByTag);
    private static _paramToAttrByTag = Schema.AttributeSchema._assignTagNames({
        "<span>, <div>": {}
    }, FormMessage._tagsByTag);
    private static _nonParamAttrsByTag = Schema.AttributeSchema._assignTagNames({
        "<span>, <div>": {}
    }, FormMessage._tagsByTag);
    private static _mandatoryParams = {};

    protected _className = FormMessage.className;
    protected _allParamsByTag = FormMessage._allParamsByTag;
    protected _attrToParamByTag = FormMessage._attrToParamByTag;
    protected _mandatoryParams = FormMessage._mandatoryParams;
    protected _nonParamAttrsByTag = FormMessage._nonParamAttrsByTag;

    constructor(tagName: string, params: FormMessage_Params) {
        super(tagName, params);

        if (process.env.NODE_ENV !== 'production') {
            const classConstraints: Schema.Constraint[] = [
                {
                    "xpath": "boolean(@title and @title != '') or boolean(.//text()[normalize-space(.) != ''])",
                    "description": "Element must contain text nodes or title attribute"
                },
                {
                    "xpath": "not(boolean((.//*[@role and @role != 'none' and @role != 'presentation'] | .//a | .//area | .//button | .//input | .//object | .//select | .//textarea)[not(ancestor-or-self::*/@aria-hidden = 'true')]))",
                    "description": "Element cannot contain other accessible elements"
                }
            ];

            const tagConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({}, FormMessage._tagsByTag)[tagName];

            const paramConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({
                "<span>, <div>": {}
            }, FormMessage._tagsByTag)[tagName];

            const paramOptionalConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({
                "<span>, <div>": {}
            }, FormMessage._tagsByTag)[tagName];

            this.getConstraints = () => {
                const constraints: Schema.ParamConstraint[] = classConstraints.slice(0);

                if (tagConstraints) {
                    Array.prototype.push.apply(constraints, tagConstraints);
                }

                for (let paramName of Object.keys(paramConstraints)) {
                    if (paramName in this._params) {
                        Array.prototype.push.apply(constraints, paramConstraints[paramName].map(c => {
                            return { ...c, name: paramName, value: this._params[paramName as keyof FormMessage_Params] };
                        }));
                    }
                }

                for (let paramName of Object.keys(paramOptionalConstraints)) {
                    const paramNames = paramName.split(', ');
                    const paramNamesText = paramNames.map(p => `'${ p }'`).join(' or ');

                    if (!(paramNames.some(n => n in this._params))) {
                        Array.prototype.push.apply(
                            constraints,
                            paramOptionalConstraints[paramName].map(c => { return { ...c, param: paramNamesText }; })
                        );
                    }
                }

                return constraints;
            };
        }
    }

    static fromAttributes(tagName: string, attributes: HTMLElementAttributes): FormMessage {
        const pd = Schema.AttributeSchema._getParamsFromAttributes<FormMessage_Params>(
            tagName,
            attributes,
            FormMessage.className,
            FormMessage._allParamsByTag,
            FormMessage._attrToParamByTag,
            FormMessage._paramToAttrByTag,
            FormMessage._mandatoryParams,
            FormMessage._nonParamAttrsByTag
        );

        const instance = new FormMessage(tagName, pd.params);

        instance._setDefaults(pd.defaults);

        return instance;
    }
}


export type FormLabel_Params = {
    
}

export class FormLabel extends Schema.AttributeSchema<FormLabel_Params> {
    static className = "FormLabel";
    private static _tagsByTag: Schema.TagsByTag = {"label":"<label>"};
    private static _allParamsByTag = Schema.AttributeSchema._assignTagNames({
        "<label>": {}
    }, FormLabel._tagsByTag);
    private static _attrToParamByTag = Schema.AttributeSchema._assignTagNames({
        "<label>": {}
    }, FormLabel._tagsByTag);
    private static _paramToAttrByTag = Schema.AttributeSchema._assignTagNames({
        "<label>": {}
    }, FormLabel._tagsByTag);
    private static _nonParamAttrsByTag = Schema.AttributeSchema._assignTagNames({
        "<label>": {}
    }, FormLabel._tagsByTag);
    private static _mandatoryParams = {};

    protected _className = FormLabel.className;
    protected _allParamsByTag = FormLabel._allParamsByTag;
    protected _attrToParamByTag = FormLabel._attrToParamByTag;
    protected _mandatoryParams = FormLabel._mandatoryParams;
    protected _nonParamAttrsByTag = FormLabel._nonParamAttrsByTag;

    constructor(tagName: string, params: FormLabel_Params) {
        super(tagName, params);

        if (process.env.NODE_ENV !== 'production') {
            const classConstraints: Schema.Constraint[] = [
                {
                    "xpath": "boolean(@title and @title != '') or boolean(.//text()[normalize-space(.) != ''])",
                    "description": "Element must contain text nodes or title attribute"
                },
                {
                    "xpath": "not(boolean((.//*[@role and @role != 'none' and @role != 'presentation'] | .//a | .//area | .//button | .//input | .//object | .//select | .//textarea)[not(ancestor-or-self::*/@aria-hidden = 'true')]))",
                    "description": "Element cannot contain other accessible elements"
                }
            ];

            const tagConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({
                "<label>": [
                    {
                        "xpath": "not(boolean((.//*[@role and @role != 'none' and @role != 'presentation'] | .//a | .//area | .//button | .//input | .//object | .//select | .//textarea)[not(ancestor-or-self::*/@aria-hidden = 'true')]))",
                        "description": "Element cannot contain other accessible elements"
                    },
                    {
                        "xpath": ".//label[@id and boolean(normalize-space(.//text()) != '')] | .//button | .//*[@role='checkbox']",
                        "description": "Label should always have id and some text content"
                    }
                ]
            }, FormLabel._tagsByTag)[tagName];

            const paramConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({
                "<label>": {}
            }, FormLabel._tagsByTag)[tagName];

            const paramOptionalConstraints: Schema.TagConstraints = Schema.AttributeSchema._assignTagNames({
                "<label>": {}
            }, FormLabel._tagsByTag)[tagName];

            this.getConstraints = () => {
                const constraints: Schema.ParamConstraint[] = classConstraints.slice(0);

                if (tagConstraints) {
                    Array.prototype.push.apply(constraints, tagConstraints);
                }

                for (let paramName of Object.keys(paramConstraints)) {
                    if (paramName in this._params) {
                        Array.prototype.push.apply(constraints, paramConstraints[paramName].map(c => {
                            return { ...c, name: paramName, value: this._params[paramName as keyof FormLabel_Params] };
                        }));
                    }
                }

                for (let paramName of Object.keys(paramOptionalConstraints)) {
                    const paramNames = paramName.split(', ');
                    const paramNamesText = paramNames.map(p => `'${ p }'`).join(' or ');

                    if (!(paramNames.some(n => n in this._params))) {
                        Array.prototype.push.apply(
                            constraints,
                            paramOptionalConstraints[paramName].map(c => { return { ...c, param: paramNamesText }; })
                        );
                    }
                }

                return constraints;
            };
        }
    }

    static fromAttributes(tagName: string, attributes: HTMLElementAttributes): FormLabel {
        const pd = Schema.AttributeSchema._getParamsFromAttributes<FormLabel_Params>(
            tagName,
            attributes,
            FormLabel.className,
            FormLabel._allParamsByTag,
            FormLabel._attrToParamByTag,
            FormLabel._paramToAttrByTag,
            FormLabel._mandatoryParams,
            FormLabel._nonParamAttrsByTag
        );

        const instance = new FormLabel(tagName, pd.params);

        instance._setDefaults(pd.defaults);

        return instance;
    }
}


if (process.env.NODE_ENV !== 'production') {
    DevEnv.addClass('Body', Body);
    DevEnv.addClass('Header1', Header1);
    DevEnv.addClass('TreeItem', TreeItem);
    DevEnv.addClass('TreeTitle', TreeTitle);
    DevEnv.addClass('Button', Button);
    DevEnv.addClass('LoadingButton', LoadingButton);
    DevEnv.addClass('PopupButton', PopupButton);
    DevEnv.addClass('ToolbarItem', ToolbarItem);
    DevEnv.addClass('Checkbox', Checkbox);
    DevEnv.addClass('RadioGroupItem', RadioGroupItem);
    DevEnv.addClass('FormField', FormField);
    DevEnv.addClass('FormInput', FormInput);
    DevEnv.addClass('FormRadioGroup', FormRadioGroup);
    DevEnv.addClass('FormDropdown', FormDropdown);
    DevEnv.addClass('FormMessage', FormMessage);
    DevEnv.addClass('FormLabel', FormLabel);
}
